/* ============================================================
   JV Team Dashboard — Shopify Bridge Mode
   Transplanted from GAS TeamDashboardEnhanced.html
   google.script.run calls replaced with jvBridge.callTeam()
   ============================================================ */

/* ============================================================
   GOOGLE.SCRIPT.RUN CALL SITE MAP
   ============================================================
   1. jvApiCall('team_app_get_dashboard', ...)
      -> jvBridge.callTeam('bridge_team_getDashboard', ...)
   2. jvApiCall('team_app_search_brides', ...)
      -> jvBridge.callTeam('bridge_team_searchBrides', ...)
   3. team_app_complete_task (comment-only in source)
      -> TODO: bridge route needed for task completion
   4. team_app_respond_to_poll (comment-only in source)
      -> jvBridge.callTeam('bridge_team_respondAvailability', ...)
   ============================================================ */

var hasBridge = (typeof window.jvBridge !== 'undefined' && typeof window.jvBridge.callTeam === 'function');

/* ============================================================
   DASHBOARD CACHE -- metafield embedded by jv-team-dashboard.liquid
   Precomputed by JV_teamDashboardCache_refreshAll() in GAS.
   Age limit: 30 minutes. Older cache triggers a foreground GAS fetch.
   ============================================================ */
var _dashboardCache = null;
var _CACHE_MAX_AGE_MS = 30 * 60 * 1000;
(function() {
  try {
    var el = document.getElementById('jv-team-cache');
    if (el) {
      var parsed = JSON.parse(el.textContent.trim() || 'null');
      if (parsed && typeof parsed === 'object' && parsed.cached_at) {
        _dashboardCache = parsed;
      }
    }
  } catch (e) {
    _dashboardCache = null;
  }
})();

/* ============================================================
   LOCALSTORAGE LAYER (stale-while-revalidate)
   Per-device cache keyed by team-member email. Set after every
   successful background GAS refresh so repeat visits paint instantly
   even before the metafield JSON parses. Layered-cache rollout
   2026-06-02 (BRIEFS/portal-perf-layered-cache-rollout-2026-06-01.md).
   ============================================================ */
function _dashLsKey_() {
  var em = (window.jvAuth && window.jvAuth.email) || '';
  return em ? ('jv_team_dash_' + String(em).toLowerCase()) : null;
}

function _readLocalDash_() {
  try {
    var k = _dashLsKey_();
    if (!k) return null;
    var raw = window.localStorage.getItem(k);
    if (!raw) return null;
    var parsed = JSON.parse(raw);
    return (parsed && parsed.cached_at) ? parsed : null;
  } catch (e) { return null; }
}

function _writeLocalDash_(data) {
  try {
    var k = _dashLsKey_();
    if (!k || !data) return;
    window.localStorage.setItem(k, JSON.stringify(data));
  } catch (e) { /* private mode / quota -- non-fatal */ }
}

/**
 * Returns the freshest available cached dashboard (localStorage vs the
 * Liquid-embedded metafield), or null if neither exists. localStorage is
 * usually newer (written on each background refresh); the metafield is
 * baked at the 5am cron.
 */
function _bestDashCache_() {
  var ls = _readLocalDash_();
  var mf = _dashboardCache;
  var lsT = (ls && ls.cached_at) ? new Date(ls.cached_at).getTime() : 0;
  var mfT = (mf && mf.cached_at) ? new Date(mf.cached_at).getTime() : 0;
  if (!lsT && !mfT) return null;
  return (lsT >= mfT) ? ls : mf;
}

/* ============================================================
   STATE
   ============================================================ */
var STATE = {
  artistName: '',
  artistRole: 'Lead Artist',
  skills: { hair: true, makeup: true, canLead: true },
  currentTab: 'dashboard',
  todaySchedule: [],
  upcomingBrides: [],
  openTasks: [],
  polls: [],
  searchResults: [],
  // P0/P1 fix (2026-08-12, BRIEFS/BUILD-team-app-consolidated-p0-p1-p2-2026-08-12.md):
  // an empty array and a NEVER-CONFIRMED array must never render the same "nothing
  // here" copy. Confirmed live: /pages/team-dashboard showed "0 jobs / Enjoy your day
  // off!" while the underlying fetch was 404ing (TEAM_NOT_AUTHENTICATED) -- a
  // contractor could read that as "nothing booked today" on a real wedding morning.
  // todaySchedule/openTasks/polls/upcomingBrides all arrive together in ONE dashboard
  // payload, so one flag covers all four -- true only after renderDashboardData() has
  // been called with a real data object (from cache OR a live res.ok===true response)
  // at least once this load. This is the render-side fix; the Cloudflare
  // TEAM_NOT_AUTHENTICATED auth root cause is a separate, already-tracked thread.
  _dashboardConfirmed: false
};

/* ============================================================
   DATE HELPERS — Australian format
   ============================================================ */
var AU_MONTHS = ['January','February','March','April','May','June',
  'July','August','September','October','November','December'];
var AU_MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun',
  'Jul','Aug','Sep','Oct','Nov','Dec'];
var AU_DAYS_SHORT = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

function escHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function ordinalSuffix(d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

function formatDateAU(dateStr) {
  if (!dateStr) return '';
  var d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  var day = d.getDate();
  return AU_DAYS_SHORT[d.getDay()] + ' ' + day + ordinalSuffix(day) + ' ' +
    AU_MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatTaskDate(dateStr) {
  if (!dateStr) return '';
  var date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  var today = new Date();
  var tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  if (date.toDateString() === today.toDateString()) return 'Today';
  if (date.toDateString() === tomorrow.toDateString()) return 'Tomorrow';

  var day = date.getDate();
  return day + ordinalSuffix(day) + ' ' + AU_MONTHS_SHORT[date.getMonth()];
}

function formatWeddingDate(dateStr) {
  return formatDateAU(dateStr);
}

function formatGreetingDate() {
  var today = new Date();
  var day = today.getDate();
  var formatted = AU_DAYS_SHORT[today.getDay()] + ' ' +
    day + ordinalSuffix(day) + ' ' + AU_MONTHS_SHORT[today.getMonth()];
  document.getElementById('greetingDate').textContent = formatted;
}

function formatScheduleDateHeader(dateStr) {
  var d = new Date(dateStr + 'T00:00:00');
  if (isNaN(d.getTime())) return dateStr;
  var day = d.getDate();
  return AU_DAYS_SHORT[d.getDay()] + ' ' + day + ordinalSuffix(day) + ' ' +
    AU_MONTHS_SHORT[d.getMonth()];
}

/* P1 (2026-06-12): local (device-timezone) Y-M-D. NOT new Date().toISOString(),
   which is UTC and rolls the date back a day before ~10-11am Sydney -- that made
   the Schedule "TODAY" header disagree with the (local) greeting date. */
function localDateISO_(d) {
  d = d || new Date();
  var m = d.getMonth() + 1, day = d.getDate();
  return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
}

/* P3 (2026-06-12, FE interim): a location value that is actually a meeting join
   link (virtual consult/trial) -- the BE puts the Zoom URL in the location slot. */
function jvIsJoinUrl_(s) {
  return /^https?:\/\//i.test(String(s == null ? '' : s).trim());
}

/* Render the location cell: a "Join Zoom" ghost pill for virtual jobs (so it is a
   tappable affordance, not raw URL text), plain text for a physical venue, and
   nothing when blank. */
function jvRenderLocationCell_(loc, cls, meetingUrl) {
  var v = String(loc == null ? '' : loc).trim();
  var mu = String(meetingUrl == null ? '' : meetingUrl).trim();
  // Prefer the explicit meetingUrl field (the BE now provides it for virtual
  // jobs); fall back to a join URL still sitting in the location slot (interim
  // payloads, before the BE enrichment reaches the cache).
  var joinUrl = jvIsJoinUrl_(mu) ? mu : (jvIsJoinUrl_(v) ? v : '');
  if (joinUrl) {
    var label = /zoom/i.test(joinUrl) ? 'Join Zoom' : 'Join meeting';
    var pill = '<a class="jv-join-zoom" href="' + escHtml(joinUrl) + '" target="_blank" rel="noopener noreferrer">' +
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>' +
      '<span>' + escHtml(label) + '</span></a>';
    // Show a human location label (e.g. "Online") above the pill when present.
    if (v && !jvIsJoinUrl_(v)) return '<div class="' + cls + '">' + escHtml(v) + '</div>' + pill;
    return pill;
  }
  if (!v) return '';
  return '<div class="' + cls + '">' + escHtml(v) + '</div>';
}

/* ============================================================
   INITIALIZATION
   ============================================================ */
document.addEventListener('DOMContentLoaded', init);

function init() {
  setupTabNavigation();
  applyTabDeepLink();
  setupProfileButtons();
  setupSearch();
  formatGreetingDate();
  checkAdminAccess();
  setupPendingPollsBanner();
  setupPollModalClose_();

  /* Wait for jvAuth to be set by jv-app-auth snippet */
  if (window.jvAuth && window.jvAuth.loggedIn) {
    STATE.artistName = window.jvAuth.name || 'Team Member';
    document.getElementById('artistName').textContent = STATE.artistName;
    // loadDashboardData() now also renders the pending-polls banner from the
    // folded pendingPollsCount in the dashboard payload -- no separate blocking
    // bridge_team_getPendingPolls call on load (layered-cache rollout 2026-06-02).
    loadDashboardData();
    /* Phase 1 strangler read: Cloudflare supplies only the Next Job hero.
       Existing GAS tasks/polls/today schedule remain unchanged until their
       own migration phases. Disabled by default behind shop metafield. */
    loadCloudflareNextJob();
    /* Admin-only backlog: recent trials -> Trial Companion. Own admin call,
       fired once after auth resolves. No-op for non-admin team members. */
    loadRecentTrials();
    /* Admin-only daily board: today's trials + weddings 1-click actions. */
    loadTodayBoard();
    /* Compliance banner (Team Portal Phase 2, 2026-07-24): PLI expiry warning. */
    checkComplianceBanner();
    /* Notification banner + modal (AUDIT-2026-09-19-surface-opportunities/
       TEAMAPP-02-NOTIFICATIONS-AND-PUSH.md §6.3/§6.8 item 6). Own call,
       same non-blocking pattern as the calls above -- a failure here never
       touches the rest of the dashboard. */
    loadDashboardNotifications_();
  }
}

/* ============================================================
   PHASE 1 — CLOUDFLARE NEXT JOB
   ============================================================ */
function jvCfRoleLabel_(role) {
  if (role === 'lead') return 'Lead Artist';
  if (role === 'support') return 'Support Artist';
  return 'Artist';
}

function jvCfFormatDate_(iso) {
  if (!iso) return '';
  var d = new Date(iso + 'T00:00:00');
  if (isNaN(d.getTime())) return iso;
  try {
    return new Intl.DateTimeFormat('en-AU', {
      weekday: 'long', day: 'numeric', month: 'long'
    }).format(d);
  } catch (_) {
    return formatWeddingDate(iso);
  }
}

function renderCloudflareNextJob_(job, cacheMeta) {
  var card = document.getElementById('jvNextJob');
  if (!card || !job) return;

  var today = localDateISO_(new Date());
  document.getElementById('jvNextJobEyebrow').textContent =
    job.weddingDate === today ? 'Today' : 'Next Job';
  document.getElementById('jvNextJobDate').textContent = jvCfFormatDate_(job.weddingDate);
  document.getElementById('jvNextJobName').textContent = job.clientDisplayName || 'Wedding';
  document.getElementById('jvNextJobVenue').textContent =
    (job.venue && job.venue.name) || 'Venue details to follow';
  document.getElementById('jvNextJobRole').textContent =
    jvCfRoleLabel_(job.assignment && job.assignment.role);
  document.getElementById('jvNextJobStart').textContent =
    (job.timing && job.timing.startLabel) || 'TBC';
  document.getElementById('jvNextJobLink').href =
    '/pages/team-job?job=' + encodeURIComponent(job.id);

  // "View Look" (2026-08-13). Only shown when a bride customer ID is present.
  var lookLink = document.getElementById('jvNextJobLookLink');
  if (lookLink) {
    if (job.brideShopifyCustomerId) {
      lookLink.href = '/pages/bridal-look-handover?c=' + encodeURIComponent(job.brideShopifyCustomerId);
      lookLink.style.display = '';
    } else {
      lookLink.style.display = 'none';
    }
  }

  var freshness = document.getElementById('jvNextJobFreshness');
  if (freshness) {
    freshness.textContent = cacheMeta && cacheMeta.offline
      ? 'Saved on this device'
      : (cacheMeta && cacheMeta.cached ? 'Refreshing…' : '');
  }

  card.hidden = false;
}

function loadCloudflareNextJob() {
  if (dashboardD1ReadEnabled_()) return;
  /* Admin accounts use a different operational model and may not have a
     team_members row. Keep their existing Dashboard behaviour untouched. */
  if (window.jvAuth && window.jvAuth.role === 'admin') return;
  if (!window.jvTeamApi || !window.jvTeamApi.isEnabled()) return;

  var cached = window.jvTeamApi.cachedJobs();
  if (cached && cached.payload && Array.isArray(cached.payload.jobs) && cached.payload.jobs.length) {
    renderCloudflareNextJob_(cached.payload.jobs[0], {
      cached: true,
      offline: !navigator.onLine,
      fetchedAt: cached.fetchedAt
    });
  }

  if (!navigator.onLine) return;

  window.jvTeamApi.getJobs().then(function(data) {
    var jobs = data && Array.isArray(data.jobs) ? data.jobs : [];
    if (!jobs.length) {
      var card = document.getElementById('jvNextJob');
      if (card) card.hidden = true;
      return;
    }
    renderCloudflareNextJob_(jobs[0], {});
  }).catch(function() {
    /* Strangler safety: keep the cached hero if present; otherwise the existing
       GAS dashboard remains the complete fallback. Never block Home. */
  });
}

/* ============================================================
   NOTIFICATION BANNER + MODAL (AUDIT-2026-09-19-surface-opportunities/
   TEAMAPP-02-NOTIFICATIONS-AND-PUSH.md §6.3/§6.8 item 6)

   The dashboard's own bridge_team_getDashboard payload does not include
   notifications (that's a separate call, team_app_get_notifications,
   previously only fetched by the notifications centre page). This is the
   dashboard's own fetch, additive, never blocking anything else on the
   page. Renders via window.JVNotif (assets/jv-notifications.js):
     - action/urgent/morning unread items -> the banner mount (#jvNotifBanner)
     - urgent/morning unread items -> the acknowledgement-required modal,
       queued one at a time
   Acknowledgement reuses bridge_team_markNotificationRead -- the spec's own
   words: "Acknowledgement is a server write, so it survives a device
   change" -- rather than inventing a parallel acknowledge endpoint.
   ============================================================ */
function loadDashboardNotifications_(notifsFromPage) {
  if (!window.JVNotif) return; // jv-notifications.js not loaded on this page -- never throw
  // Cloudflare mode: the page view already carries the notifications, so the
  // separate GAS bridge_team_getNotifications call is not made.
  if (Array.isArray(notifsFromPage)) { renderDashboardNotifications_(notifsFromPage); return; }
  if (dashboardD1ReadEnabled_()) return; // Cloudflare mode: notifications arrive with the page view only
  if (!window.jvBridge || typeof window.jvBridge.callTeam !== 'function') return;

  // Issue #3 (C7, 2026-10-19): CF-first notifications. Tri-state window.JV_TEAM_NOTIFS_CF_ENABLED
  // 'off' (default) | 'shadow' (render GAS, log CF) | 'on' (CF authoritative; no GAS fallback).
  // Same-origin App Proxy GET: identity comes from the Shopify signature server-side -- this code
  // sends NO email. The old /jv/team-notifications POST-with-email design was rejected for that.
  var nRaw = window.JV_TEAM_NOTIFS_CF_ENABLED;
  var nMode = (nRaw === true || String(nRaw).toLowerCase() === 'true')
    ? 'on'
    : String(nRaw || 'off').toLowerCase();
  if (nMode === 'on') {
    teamNotifsCfGet_().then(function(cfRes) {
      if (cfRes && cfRes.ok && cfRes.data) {
        renderDashboardNotifications_(Array.isArray(cfRes.data) ? cfRes.data : (cfRes.data.notifications || []));
        return;
      }
      try { console.error('[JV_TEAM_NOTIFS_CF_FAILED] Cloudflare notifications read failed; GAS fallback retired'); } catch (_e) {}
    });
    return;
  }
  if (nMode === 'shadow') {
    teamNotifsCfGet_().then(function(cfRes) {
      try { console.info('[jv-team-notifications CF shadow] cf_ok=' + !!(cfRes && cfRes.ok) + ' count=' + (cfRes && cfRes.count)); } catch (_e) {}
    });
  }
  loadDashboardNotificationsGas_();
}

function teamNotifsCfGet_() {
  var timeoutMs = Number(window.JV_TEAM_CF_TIMEOUT_MS) > 0 ? Number(window.JV_TEAM_CF_TIMEOUT_MS) : 6000;
  var timer = null;
  var timeout = new Promise(function(resolve) {
    timer = setTimeout(function() { resolve({ ok: false, _cfTimeout: true }); }, timeoutMs);
  });
  var call;
  try {
    var proxyBase = (window.jvBridge && window.jvBridge.appProxyBase) || '/apps/jv';
    var nf = (window._jvNativeFetch || window.fetch).bind(window);
    call = nf(proxyBase.replace(/\/+$/, '') + '/team-notifications/cache?limit=50', { method: 'GET', credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.json() : { ok: false, _cfStatus: r.status }; })
      .catch(function(e) { return { ok: false, _cfError: String(e && e.message || e) }; });
  } catch (e2) {
    call = Promise.resolve({ ok: false, _cfError: String(e2 && e2.message || e2) });
  }
  return Promise.race([call, timeout]).then(function(v) { clearTimeout(timer); return v; });
}

function loadDashboardNotificationsGas_() {
  window.jvBridge.callTeam('bridge_team_getNotifications', { limit: 50 })
    .then(function(res) {
      if (!res || !res.ok || !res.data) return;
      var notifs = Array.isArray(res.data) ? res.data : (res.data.notifications || []);
      renderDashboardNotifications_(notifs);
    }).catch(function() {});
}

function renderDashboardNotifications_(notifs) {
  if (!window.JVNotif) return;
  {
      if (!notifs.length) return;

      var bannerEl = document.getElementById('jvNotifBanner');
      if (bannerEl) {
        window.JVNotif.renderBanner(bannerEl, notifs, {
          onAction: function (item) { if (item.actionUrl) window.location.href = item.actionUrl; },
          centreUrl: '/pages/team-notifications'
        });
      }

      // urgent -> the acknowledgement-required modal (Component C).
      // morning now gets its OWN louder treatment below (Component D, the
      // full-bleed alert bar) -- pulled out of the modal path added 2026-09-21
      // when Component D shipped; a 'morning' item was routing to the same
      // modal as 'urgent' before this, which the spec never intended (§6.2's
      // own table gives morning a distinct "full-width sticky alert bar", not
      // a modal).
      var modalWorthy = notifs.filter(function (n) {
        return n && n.read !== true && n.priority === 'urgent';
      });
      if (modalWorthy.length) {
        window.JVNotif.showModal(modalWorthy, {
          onAcknowledge: function (item) {
            return teamWriteNotifRead_(item.id);
          },
          onOpenJob: function (item) { if (item.actionUrl) window.location.href = item.actionUrl; }
        });
      }

      // morning -> Component D (added 2026-09-21, §6.3/§6.8 item 7). Only
      // ever the SOONEST unread morning item -- the bar shows one line, one
      // job, not a queue like the modal. isMorningBarActive itself already
      // no-ops outside the active window, so this is safe to call even for
      // an old/irrelevant morning row; the mount just stays hidden.
      var morningEl = document.getElementById('jvMorningBar');
      if (morningEl) {
        var morningItem = notifs.filter(function (n) {
          return n && n.read !== true && n.priority === 'morning';
        })[0];
        if (morningItem) {
          window.JVNotif.showMorningBar(morningEl, morningItem, {
            onAcknowledge: function (item) {
              return teamWriteNotifRead_(item.id);
            }
          });
        }
      }
  }
}

/* ============================================================
   COMPLIANCE BANNER (Team Portal Phase 2, 2026-07-24;
   extended for WWCC + Code-of-Conduct, Phase 4, 2026-07-28)
   -- shows a persistent warning strip when the artist's PLI or WWCC is
   missing/expiring, or their signed Code of Conduct is out of date.
   Fails silently (never blocks the rest of the dashboard).

   NOTE (2026-07-28): the record is now custom.artist_identity_json (local-
   first migration), so the field keys are camelCase (plIExpiry / wwccExpiry
   / codeOfConductVersionSigned), NOT the old uppercase Sheet keys. The
   pre-migration banner read res.data.PLI_EXPIRY and was silently dead post-
   migration -- fixed here.

   CDN FAST PATH (2026-09-23, AUDIT-TEAMAPP-xray-2026-09-20.md P1 "cheapest
   win in the whole audit" -- bridge_team_getComplianceStatus/
   getOnboardingStatus together cost ~44s of GAS wall per dashboard load,
   reading data already server-rendered on the page as of this fix). Reads
   the #jv-compliance-bootstrap island (sections/jv-team-dashboard.liquid)
   first -- customer.metafields.custom.artist_identity_json plus the
   current published CoC/policy versions from shop.metaobjects.team_conduct_doc/
   team_policy_doc, all CDN-served, zero GAS calls. Falls back to the
   original two GAS routes only if the island is missing/empty (e.g. a
   customer with no artist_identity_json yet, or this section rendered
   somewhere the island wasn't added) -- never a silent regression.
   ============================================================ */
function checkComplianceBanner() {
  var banner = document.getElementById('jvComplianceBanner');
  var text = document.getElementById('jvComplianceBannerText');
  if (!banner || !text) return;

  // Whole days until an ISO 'yyyy-MM-dd' expiry; null if blank/unparseable.
  function daysUntil(iso) {
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(String(iso).trim())) return null;
    var d = new Date(String(iso).trim() + 'T00:00:00');
    if (isNaN(d.getTime())) return null;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    return Math.ceil((d - today) / (1000 * 60 * 60 * 24));
  }

  // Build the single most-urgent message across all compliance items.
  // urgency: 3=lapsed/missing-required, 2=<=14d, 1=<=30d, 0=fine.
  function evaluate(record, onboarding) {
    var candidates = [];

    ['plI', 'wwcc'].forEach(function(prefix) {
      var label = prefix === 'plI' ? 'Public Liability Insurance' : 'Working With Children Check';
      var expiry = record[prefix + 'Expiry'];
      if (!expiry) {
        candidates.push({ urgency: 3, text: 'Please complete your onboarding, including your ' + label + ' details.' });
        return;
      }
      var days = daysUntil(expiry);
      if (days === null) return;
      if (days <= 0) candidates.push({ urgency: 3, text: 'Your ' + label + ' has expired. Please update it as soon as possible.' });
      else if (days <= 14) candidates.push({ urgency: 2, text: 'Your ' + label + ' expires in ' + days + ' day' + (days === 1 ? '' : 's') + '.' });
      else if (days <= 30) candidates.push({ urgency: 1, text: 'Your ' + label + ' expires in ' + days + ' days.' });
    });

    // Code of Conduct re-sign nudge: onboarding tells us the version the
    // artist signed; a mismatch with the current published version (surfaced
    // by the BE as needsResign) means please re-sign.
    if (onboarding && onboarding.needsResign) {
      candidates.push({ urgency: 2, text: 'Our Code of Conduct has been updated. Please review and re-sign it.' });
    } else if (onboarding && onboarding.needsResignRates) {
      candidates.push({ urgency: 2, text: 'Your rates have been updated. Please review and re-sign your agreement.' });
    }

    if (!candidates.length) return null;
    candidates.sort(function(a, b) { return b.urgency - a.urgency; });
    return candidates[0];
  }

  function renderPick(pick) {
    banner.classList.remove('jv-compliance-banner--urgent');
    if (!pick) { banner.style.display = 'none'; return; }
    text.textContent = pick.text;
    if (pick.urgency >= 2) banner.classList.add('jv-compliance-banner--urgent');
    banner.style.display = 'flex';
  }

  // Mirrors teamPolicyDocs_cmpVersion_ (TeamPolicyDocs_2026_07_28.gs)
  // exactly -- dotted-numeric compare, missing parts treated as 0.
  function cmpVersion(a, b) {
    var pa = String(a || '0').split('.').map(function(x) { return parseInt(x, 10) || 0; });
    var pb = String(b || '0').split('.').map(function(x) { return parseInt(x, 10) || 0; });
    var n = Math.max(pa.length, pb.length);
    for (var i = 0; i < n; i++) {
      var x = pa[i] || 0, y = pb[i] || 0;
      if (x < y) return -1;
      if (x > y) return 1;
    }
    return 0;
  }

  // Mirrors teamConduct_needsResign_/teamPolicies_needsReack_ exactly.
  function needsResignOrReack(signedOrAcked, current) {
    if (!current) return false; // nothing published -> nothing to sign
    if (!signedOrAcked) return true; // published but never signed/acked
    return cmpVersion(signedOrAcked, current) < 0;
  }

  function tryCdnFastPath() {
    var el = document.getElementById('jv-compliance-bootstrap');
    if (!el) return null;
    var boot;
    try { boot = JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
    if (!boot || !boot.identity) return null; // no artist_identity_json yet -- fall back
    var onboarding = {
      needsResign: needsResignOrReack(boot.identity.codeOfConductVersionSigned, boot.coCVersion),
      needsReack: needsResignOrReack(boot.identity.policiesAcknowledgedVersion, boot.policyVersion)
    };
    return { record: boot.identity, onboarding: onboarding };
  }

  function legacyGasFetch() {
    Promise.all([
      jvBridge.callTeam('bridge_team_getComplianceStatus', {}).catch(function() { return null; }),
      jvBridge.callTeam('bridge_team_getOnboardingStatus', {}).catch(function() { return null; })
    ]).then(function(results) {
      var compRes = results[0], onbRes = results[1];
      if (!compRes || !compRes.ok || !compRes.data) return; // fail silent
      var onboarding = (onbRes && onbRes.ok && onbRes.data) ? onbRes.data : null;
      renderPick(evaluate(compRes.data, onboarding));
    }).catch(function() { /* fail silently -- banner is a nice-to-have, never block the dashboard */ });
  }

  var fastPath = tryCdnFastPath();
  if (fastPath) {
    renderPick(evaluate(fastPath.record, fastPath.onboarding));
    return;
  }
  legacyGasFetch();
}

/* ============================================================
   PENDING-POLLS BANNER
   Calls team_app_get_pending_polls — shows a top banner when
   pendingCount > 0. Tapping scrolls to the Availability card.
   ============================================================ */
function setupPendingPollsBanner() {
  var banner = document.getElementById('pendingPollsBanner');
  if (!banner) return;
  banner.addEventListener('click', function() {
    var card = document.getElementById('availabilityCard');
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      card.style.display = 'block';
    }
  });
}

function renderPendingPollsBanner(count) {
  var banner = document.getElementById('pendingPollsBanner');
  var countEl = document.getElementById('pendingPollsCount');
  var pluralEl = document.getElementById('pendingPollsPlural');
  if (!banner || !countEl) return;

  if (!count || count <= 0) {
    banner.style.display = 'none';
    banner.setAttribute('aria-hidden', 'true');
    return;
  }
  countEl.textContent = String(count);
  if (pluralEl) pluralEl.textContent = count === 1 ? '' : 's';
  banner.style.display = '';
  banner.setAttribute('aria-hidden', 'false');
}

/* D1-native pending-polls read (2026-09-23, Team App/Portal, Slice 3 of
   state/findings/PLAN-availability-poll-cloudflare-rebuild-2026-09-23.md).
   D1-native replacement for team_app_get_pending_polls (ChatBot.gs), which
   has a documented 349-529s live GAS timeout history. Ships dark behind
   pollPendingReadEnabled -- a complete no-op when off, so this function is
   safe to call unconditionally from renderDashboardData.

   Maps the D1 response shape ({pollId, brideName, weddingDate, sentAt,
   myResponse}) onto the SAME poll shape renderAvailability/the poll modal
   already expect ({id, couple, weddingDate, weddingDateIso, myResponse}) --
   no changes needed to either render function, this only swaps the DATA
   SOURCE feeding STATE.polls. weddingDateIso and weddingDate are the SAME
   value here (D1 stores wedding_date as ISO already) -- GAS's dashboard
   payload historically carried both as potentially-different strings (a
   display format vs an ISO one), D1 does not have that split.

   OVERRIDES STATE.polls (does not merge) -- D1 is the more complete, more
   current source once this flag is on; a GAS/D1 hybrid list would risk
   showing a poll twice under two different id shapes if the artist has
   pending polls from both eras during the flag-flip transition. */
function loadPendingPollsFromD1_() {
  if (dashboardD1ReadEnabled_()) return;
  if (!window.jvTeamApi || !window.jvTeamApi.pollPendingReadEnabled || !window.jvTeamApi.pollPendingReadEnabled()) return;

  var cached = window.jvTeamApi.cachedPendingPolls && window.jvTeamApi.cachedPendingPolls();
  if (cached && cached.payload) applyPendingPollsFromD1_(cached.payload);

  window.jvTeamApi.getPendingPolls().then(function(data) {
    applyPendingPollsFromD1_(data);
  }).catch(function(err) {
    // Fail silent -- GAS's own dashboard payload already painted STATE.polls
    // above, so a D1 read failure just means the artist sees the (correct,
    // if slower-updating) GAS-sourced list instead of no list at all.
    console.warn('D1 pending-polls read failed, GAS-sourced list stands:', err);
    if (window.jvTeamApi && window.jvTeamApi.reportFallback) window.jvTeamApi.reportFallback('poll_pending_read', err);
  });
}

/* BUG FIX (2026-10-07, break 7): in Cloudflare dashboard mode (dashboardD1Read ON) page.polls arrives in the RAW D1 shape
   {pollId, brideName, weddingDate, myResponse, ...}, but every poll renderer/responder reads the GAS shape {id, couple,
   weddingDateIso, responded}. Result: cards rendered with data-poll-id="undefined" (D1 respond rejected, the answered poll
   was never dropped from STATE so it kept reappearing), answered polls were listed as pending, and the "block the day?"
   follow-up never offered (no weddingDateIso). Normalised ONCE here, for cache paint and live refresh alike. GAS-shaped
   polls (they already carry an id) pass through untouched, and answered polls are dropped (the list is the TO-ANSWER list). */
function normalizePagePolls_(polls) {
  if (!Array.isArray(polls)) return [];
  var out = [];
  polls.forEach(function(p) {
    if (!p || typeof p !== 'object') return;
    if (p.id !== undefined && p.id !== null && p.id !== '') { out.push(p); return; } // already GAS-shaped: unchanged
    if (p.pollId === undefined || p.pollId === null) return;                        // unusable: no id to answer against
    var answered = p.myResponse !== undefined && p.myResponse !== null && p.myResponse !== '';
    if (answered) return;                                                            // D1 list: drop what is already answered
    out.push(Object.assign({}, p, {
      id: p.pollId,
      couple: p.couple || p.brideName,
      weddingDateIso: p.weddingDateIso || p.weddingDate || '',
      responded: false
    }));
  });
  return out;
}

function applyPendingPollsFromD1_(data) {
  if (!data || !Array.isArray(data.polls)) return;
  STATE.polls = data.polls.map(function(p) {
    return {
      id: p.pollId,
      couple: p.brideName,
      brideName: p.brideName,
      weddingDate: p.weddingDate,
      weddingDateIso: p.weddingDate,
      myResponse: p.myResponse,
      responded: p.myResponse !== undefined && p.myResponse !== null
    };
  }).filter(function(p) { return !p.responded; });
  renderPendingPollsBanner(typeof data.pendingCount === 'number' ? data.pendingCount : STATE.polls.length);
  renderAvailability();
}

/* Show Admin tab if user has admin role */
function checkAdminAccess() {
  if (window.jvAuth && (window.jvAuth.role === 'admin')) {
    var tab = document.getElementById('admin-crm-tab');
    if (tab) tab.style.display = '';
  }
}

/* ============================================================
   RECENT TRIALS (admin only) -> Trial Companion backlog
   Lists brides whose TRIAL DATE is in the last 14 days, each with a
   one-click "Open Trial Companion" deep link (/pages/trial-companion?c=<id>).
   Admin-only, because Trial Companion is a jv-admin tool.

   TRANSPORT (2026-10-01, relay-direct migration -- state/findings/FINDING-
   trial-companion-d1-contract-mismatch-2026-10-01.md): this used to call
   the GAS bridge route bridge_trialCompanion_getRecentTrials, but the live
   Cloudflare Worker route it was meant to accelerate through
   (TrialCompanionD1Reads_2026_09_23.gs) was built to a GAS-calls-Worker-
   directly contract the deployed Worker route never actually accepts (it
   requires verifiedActorType:'admin', which only the relay's own App-Proxy-
   verified dispatcher injects -- confirmed by direct read + a live curl
   probe, see the finding doc). The relay's own PROXY_ENTITIES comment names
   the correct design directly: the frontend calls the relay's
   /partner/trial-companion/<action> entity itself, same transport pattern
   already proven live by jv-admin-crm.js's publish-integrity card (search
   that file for "_jvAdminProxyBase" for the precedent this mirrors).
   window._jvAdminProxyBase is emitted by this section's own Liquid, admin-
   tag-gated to match this function's own admin-only check below.
   ============================================================ */
var _TC_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

function loadRecentTrials() {
  if (!window.jvAuth || window.jvAuth.role !== 'admin') return;
  var base = window._jvAdminProxyBase;
  if (!base) return; // Liquid gate didn't emit it (shouldn't happen for an admin, but fail quiet)

  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  var url = String(base).replace(/\/+$/, '') + '/partner/trial-companion/recent-trials';

  nf(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ days: 14 })
  })
    .then(function(r) { return r.json(); })
    .then(function(res) {
      if (!res || !res.ok || !Array.isArray(res.trials)) return;
      renderRecentTrials(res.trials);
    })
    .catch(function() { /* non-fatal: card simply stays hidden */ });
}

function renderRecentTrials(trials) {
  var card = document.getElementById('recentTrialsCard');
  var list = document.getElementById('recentTrialsList');
  var countEl = document.getElementById('recentTrialsCount');
  if (!card || !list) return;

  if (!trials.length) {
    /* Nothing in the window -- keep the card hidden so the Today view stays clean. */
    card.style.display = 'none';
    return;
  }

  card.style.display = '';
  if (countEl) countEl.textContent = trials.length + ' bride' + (trials.length !== 1 ? 's' : '');

  list.innerHTML = trials.map(function(t) {
    var href = t.companionUrl || '/pages/trial-companion';
    return '<div class="recent-trial-item">' +
      '<div class="recent-trial-info">' +
        '<div class="recent-trial-name">' + escHtml(t.name || 'Bride') + '</div>' +
        '<div class="recent-trial-date">Trial ' + escHtml(t.trialDateLabel || t.trialDate || '') + '</div>' +
      '</div>' +
      '<a class="recent-trial-open" href="' + escHtml(href) + '">' +
        'Open' + _TC_ICON +
      '</a>' +
    '</div>';
  }).join('');
}

/* ============================================================
   TODAY'S ACTIONS (admin only) -> 1-click Trial Companion / Runsheet
   Today's trials (Open Trial Companion) + today's weddings (Open Runsheet,
   read-only admin preview). Admin call, fired once on load after auth.

   TRANSPORT: same relay-direct migration as loadRecentTrials above -- see
   that function's own comment for the full root-cause trail.
   ============================================================ */
function loadTodayBoard() {
  if (!window.jvAuth || window.jvAuth.role !== 'admin') return;
  var base = window._jvAdminProxyBase;
  if (!base) return;

  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  var url = String(base).replace(/\/+$/, '') + '/partner/trial-companion/today-board';

  nf(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({})
  })
    .then(function(r) { return r.json(); })
    .then(function(res) {
      if (!res || !res.ok) return;
      renderTodayBoard(res.trials || [], res.weddings || []);
    })
    .catch(function() { /* non-fatal: card simply stays hidden */ });
}

function renderTodayBoard(trials, weddings) {
  var card = document.getElementById('todayActionsCard');
  var list = document.getElementById('todayActionsList');
  var countEl = document.getElementById('todayActionsCount');
  if (!card || !list) return;

  var total = trials.length + weddings.length;
  if (!total) { card.style.display = 'none'; return; }

  card.style.display = '';
  if (countEl) countEl.textContent = total + ' today';

  var html = '';

  trials.forEach(function(t) {
    var href = t.companionUrl || '/pages/trial-companion';
    var sub = t.time ? ('Trial ' + t.time) : 'Trial today';
    html += '<div class="today-action-item">' +
      '<div class="today-action-info">' +
        '<span class="today-action-tag today-action-tag--trial">Trial</span>' +
        '<div class="today-action-name">' + escHtml(t.name || 'Bride') + '</div>' +
        '<div class="today-action-meta">' + escHtml(sub) + '</div>' +
      '</div>' +
      '<a class="today-action-btn" href="' + escHtml(href) + '">' +
        'Open Trial Companion' + _TC_ICON +
      '</a>' +
    '</div>';
  });

  weddings.forEach(function(w) {
    var href = w.runsheetUrl || '/pages/runsheet-admin-preview';
    var bits = [];
    if (w.arrivalTime) bits.push('Arrive ' + w.arrivalTime);
    if (w.location) bits.push(w.location);
    var sub = bits.length ? bits.join(' · ') : 'Wedding today';
    html += '<div class="today-action-item">' +
      '<div class="today-action-info">' +
        '<span class="today-action-tag today-action-tag--wedding">Wedding</span>' +
        '<div class="today-action-name">' + escHtml(w.name || 'Bride') + '</div>' +
        '<div class="today-action-meta">' + escHtml(sub) + '</div>' +
      '</div>' +
      '<a class="today-action-btn" href="' + escHtml(href) + '">' +
        'Open Runsheet' + _TC_ICON +
      '</a>' +
    '</div>';
  });

  list.innerHTML = html;
}

/* ============================================================
   TAB NAVIGATION
   ============================================================ */
function setupTabNavigation() {
  document.querySelectorAll('.tab-button[data-tab]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var tabName = e.currentTarget.dataset.tab;
      if (tabName) switchTab(tabName);
    });
  });
}

/**
 * Deep-link support (2026-08-18, legacy Team App retirement,
 * BRIEFS/HANDOFF-legacy-team-app-retirement-2026-08-18.md): reads ?tab= from
 * the URL on load and switches to that tab if it names a real, existing pane.
 * Lets a redirect stub (e.g. the retired team_search_page route) land a
 * visitor on a specific tab instead of always the default "Today" view.
 * Silently ignores a missing/invalid param -- the default active tab (set in
 * the liquid markup) is already correct, nothing to do in that case.
 */
function applyTabDeepLink() {
  try {
    var params = new URLSearchParams(window.location.search);
    var tabName = String(params.get('tab') || '').trim();
    if (!tabName) return;
    var pane = document.querySelector('.tab-pane[data-tab="' + tabName + '"]');
    if (!pane) return; // unknown tab name -- leave the default active tab alone
    switchTab(tabName);
  } catch (_) {
    /* URLSearchParams / DOM access failure is non-fatal -- default tab stays active. */
  }
}

/**
 * Availability Poll modal deep-link (2026-09-10, live device test finding):
 * tapping the booking-poll push notification used to land on the wrong page
 * entirely (see ChatBot.gs's chatSendBookingNotificationWithPoll_ header
 * comment). Now that it correctly lands here, this reads ?poll_bride=/
 * ?poll_date= from the URL and, if a matching pending poll exists in
 * STATE.polls, pops it open as a modal immediately -- so the artist doesn't
 * have to find the right card in the Availability list herself. Silently
 * no-ops (falls back to the inline list, unchanged) if there's no deep-link
 * param, no match yet (data hasn't loaded), or the artist already
 * responded/dismissed it this page load.
 */
function openPollModalFromDeepLink_(isLive) {
  try {
    if (STATE._pollModalAttempted) return; // only ever auto-open once per page load
    var params = new URLSearchParams(window.location.search);
    var brideParam = String(params.get('poll_bride') || '').trim();
    if (!brideParam) return; // no deep-link -- normal inline list behaviour, nothing to do

    var poll = (STATE.polls || []).find(function(p) {
      if (!p) return false;
      var name = String(p.couple || p.brideName || '').trim().toLowerCase();
      return name === brideParam.toLowerCase() && !p.responded;
    });
    if (!poll) {
      // FIX 2026-10-02 (Cloudflare/Edge, code-read trace -- Cowork reported
      // the GAS-side unassigned-artist fix, fa48368a6, still didn't surface
      // the poll live): the PREVIOUS fix here (2026-10-01) assumed this
      // function's one call site only ever runs after the live refresh --
      // WRONG. renderDashboardData's own header comment two lines above
      // this call already says "cache paint AND live refresh", and
      // loadDashboardData() genuinely calls it from `_bestDashCache_()`
      // SYNCHRONOUSLY before the live `bridge_team_getDashboard` call even
      // starts. A fresh poll opened via push notification almost always
      // means: stale/empty cache from a prior visit -> cache-paint runs
      // first with OLD STATE.polls -> this miss fires, concludes "genuinely
      // not found", and PERMANENTLY locks via _pollModalAttempted before
      // the live data (which has the real poll) ever arrives. The GAS fix
      // may be working correctly the whole time; this timing bug masks it.
      //
      // Fix: a cache-paint miss is NOT a genuine result -- only a LIVE miss
      // is. On a cache-paint miss, leave the modal in its default
      // "checking..." state (do nothing, don't lock) so the live call gets
      // a real chance to find the poll. Only report "unavailable" once the
      // live data has had its say.
      if (!isLive) return;
      STATE._pollModalAttempted = true;
      renderPollModalUnavailable_();
      var modalMiss = document.getElementById('pollModal');
      if (modalMiss) {
        modalMiss.classList.add('is-visible');
        modalMiss.setAttribute('aria-hidden', 'false');
      }
      return;
    }

    STATE._pollModalAttempted = true;
    renderPollModalBody_(poll);

    var modal = document.getElementById('pollModal');
    if (modal) {
      modal.classList.add('is-visible');
      modal.setAttribute('aria-hidden', 'false');
    }
  } catch (_) {
    /* Deep-link is a convenience, not a required path -- any failure here
       falls back silently to the always-working inline Availability card. */
  }
}

function closePollModal_() {
  var modal = document.getElementById('pollModal');
  if (!modal) return;
  modal.classList.remove('is-visible');
  modal.setAttribute('aria-hidden', 'true');
}

/* Wires the backdrop + × button to close the poll modal -- same pattern as
   the existing .js-runsheet-modal-close convention (jv-bridal-hub-widgets.js). */
function setupPollModalClose_() {
  document.querySelectorAll('.js-poll-modal-close').forEach(function(el) {
    el.addEventListener('click', closePollModal_);
  });
}

/* FIX 2026-10-01: the "no longer actionable" state for the poll deep-link --
   already answered, expired, or just not found. Deliberately plain and
   non-alarming (this is an expected, common outcome, not an error), with no
   poll-id-specific buttons since there is nothing left to respond to. */
function renderPollModalUnavailable_() {
  var body = document.getElementById('pollModalBody');
  var titleEl = document.getElementById('pollModalTitle');
  if (titleEl) titleEl.textContent = 'Availability request';
  if (!body) return;
  body.innerHTML = '<div class="poll-item">' +
    '<div class="poll-item__eyebrow">Availability request</div>' +
    '<div class="poll-question">This poll isn\'t available anymore.</div>' +
    '<div class="poll-meta">It may have already been answered, expired, or been cancelled. ' +
    'Check the Availability tab for anything still pending.</div>' +
    '</div>';
}

/* Renders ONE poll into the modal body, reusing the exact same .poll-item/
   .poll-btn markup (and therefore the exact same CSS + click handling) as
   the inline Availability card -- no separate render logic to keep in sync. */
function renderPollModalBody_(poll) {
  var body = document.getElementById('pollModalBody');
  var titleEl = document.getElementById('pollModalTitle');
  if (!body) return;

  var brideName = poll.couple || poll.brideName || 'this wedding';
  var DEFAULT_OPTS = ['AVAILABLE', 'UNAVAILABLE', 'MAYBE'];
  var opts = (poll.options && poll.options.length) ? poll.options : DEFAULT_OPTS;

  var buttonsHtml = opts.map(function(opt) {
    var norm = String(opt).toUpperCase();
    var label = norm === 'AVAILABLE' ? 'Available'
      : norm === 'UNAVAILABLE' ? 'Unavailable'
      : norm === 'MAYBE' ? 'Maybe'
      : escHtml(opt);
    return '<button type="button" class="poll-btn" data-poll-id="' + escHtml(poll.id) + '"' +
      ' data-option="' + escHtml(norm) + '"' +
      ' data-bride-name="' + escHtml(brideName) + '"' +
      ' data-wedding-date="' + escHtml(poll.weddingDate || '') + '"' +
      ' data-wedding-date-iso="' + escHtml(poll.weddingDateIso || '') + '"' +
      ' data-has-conflict="' + (findSameDateCommitment_(poll) ? '1' : '0') + '"' +
      ' data-my-prior-response="' + escHtml(poll.myResponse || '') + '"' +
      ' aria-label="' + label + ' for ' + escHtml(brideName) + '">' +
      label + '</button>';
  }).join('');

  var locationLine = poll.weddingLocation || poll.venue || poll.location || '';
  var conflict = findSameDateCommitment_(poll);

  if (titleEl) titleEl.textContent = brideName;

  body.innerHTML = '<div class="poll-item" data-poll-id="' + escHtml(poll.id) + '">' +
    '<div class="poll-item__eyebrow">Availability request</div>' +
    '<div class="poll-title" id="pollModalTitle">' + escHtml(brideName) + '</div>' +
    '<div class="poll-date">' + formatWeddingDate(poll.weddingDate) + '</div>' +
    (locationLine ? '<div class="poll-meta">' + escHtml(locationLine) + '</div>' : '') +
    (conflict ? '<div class="poll-conflict-note">Heads up, you\'re already booked for ' +
      escHtml(conflict.brideName || 'another wedding') + ' on this date' +
      (conflict.arrivalTime ? ' (arrive ' + escHtml(conflict.arrivalTime) + ')' : '') +
      '.</div>' : '') +
    '<div class="poll-question">Can you work this date?</div>' +
    '<div class="poll-buttons">' + buttonsHtml + '</div>' +
  '</div>';

  body.querySelectorAll('.poll-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var clickedBtn = e.target.closest('.poll-btn') || e.target;
      var cardEl = clickedBtn.closest('.poll-item');
      if (cardEl && cardEl.classList.contains('is-busy')) return;
      // FIX 2026-09-12 (F1, BRIEFS/RESULTS-availability-poll-tap-through-2026-09-12.md):
      // this used to fire respondToPoll() (async, backend measured live at
      // 14.6-20.4s) and then unconditionally close the modal 900ms later via
      // setTimeout, regardless of outcome. That meant: (1) the "block the
      // whole day?" follow-up prompt (pollOfferBlockDate_, which only renders
      // once respondToPoll's own network call resolves) rendered into an
      // already-hidden modal and was never seen; (2) a FAILED response
      // (pollResponseFailed_) was visually indistinguishable from a
      // successful one, since the modal closed either way before either
      // state could be read. Fixed by passing a completion callback through
      // respondToPoll -> pollResponseConfirmed_/pollResponseFailed_ that
      // closes the modal only once the real outcome is known, and NEVER
      // auto-closes when pollOfferBlockDate_ takes over (that function
      // re-renders the same modal body in place to show the block-day
      // choice, so closing out from under it would hide that choice too).
      respondToPoll(clickedBtn.dataset.pollId, clickedBtn.dataset.option, clickedBtn, closePollModal_);
    });
  });
}

function switchTab(tabName) {
  STATE.currentTab = tabName;

  document.querySelectorAll('.tab-pane').forEach(function(pane) {
    pane.classList.remove('active');
  });
  var activePane = document.querySelector('.tab-pane[data-tab="' + tabName + '"]');
  if (activePane) activePane.classList.add('active');

  document.querySelectorAll('.tab-button').forEach(function(btn) {
    btn.classList.remove('active');
  });
  var activeBtn = document.querySelector('.tab-button[data-tab="' + tabName + '"]');
  if (activeBtn) activeBtn.classList.add('active');

  if (tabName === 'schedule') loadScheduleData();
  if (tabName === 'profile') loadProfileData();
}

/* ============================================================
   DASHBOARD DATA LOADING
   ============================================================ */

/**
 * Applies a data object (from cache or live GAS response) to STATE
 * and triggers a render. Called from both the cache path and the
 * bridge response path so render logic is not duplicated.
 *
 * @param {Object} data  shape: { today, upcoming, tasks, polls }
 */
function renderDashboardData(data, isLive) {
  STATE.artistName = STATE.artistName || (window.jvAuth && window.jvAuth.name) || 'Team Member';
  STATE.artistRole = (window.jvAuth && window.jvAuth.role) || 'Artist';
  STATE.todaySchedule = jvTodayJobs_unionWithD1_(data.today || []);
  STATE.upcomingBrides = data.upcoming || [];
  /* Contract fix (2026-09-01, external-GPT existing-value audit finding #2):
     team_app_get_dashboard / team_app_list_tasks (TeamAppAPI.gs) return
     taskId/taskText/dueAt -- this renderer used to read task.id/description/
     dueDate, none of which the backend ever sends, so every task rendered
     blank text, no due date, and completeTask() submitted an undefined ID
     on tick. Normalise ONCE here (not per-render-site) so the raw backend
     names still round-trip if anything else needs them. */
  STATE.openTasks = (data.tasks || []).map(function(t) {
    return Object.assign({}, t, {
      id: t.id || t.taskId,
      description: t.description || t.taskText,
      dueDate: t.dueDate || t.dueAt
    });
  });
  STATE.polls = normalizePagePolls_(data.polls || []);
  // P0/P1 fix: only this function -- called from a real cache paint or a genuine
  // res.ok===true live response, never from a failure path -- may confirm the
  // dashboard. See STATE._dashboardConfirmed declaration for why this exists.
  STATE._dashboardConfirmed = true;
  /* Auto-open the poll modal if this page load came from a booking-poll push
     notification (?poll_bride=...). Runs every time STATE.polls is populated
     (cache paint AND live refresh) but only actually opens once per page load
     via STATE._pollModalAttempted, so a background refresh after the artist
     already dismissed/answered the modal doesn't reopen it out from under her.
     `isLive` (2026-10-02 fix, see openPollModalFromDeepLink_'s own header)
     tells it whether THIS call is the live-confirmed one -- a cache-paint
     miss is not allowed to conclude "genuinely not found" on its own. */
  openPollModalFromDeepLink_(isLive);
  /* Store notification count from live GAS response for badge render */
  if (typeof data.unreadNotificationCount === 'number') {
    STATE._unreadNotificationCount = data.unreadNotificationCount;
  }
  /* Pending-polls banner is folded into the dashboard payload (layered-cache
     rollout) -- render it here from the cached/refreshed data so there is no
     separate blocking bridge_team_getPendingPolls cold-start on load. */
  var _pollCount = (typeof data.pendingPollsCount === 'number')
    ? data.pendingPollsCount
    : STATE.polls.filter(function(p) { return p && !p.responded; }).length; // normalised list: raw D1 polls have no `responded`
  renderPendingPollsBanner(_pollCount);
  // D1-native pending-polls read (2026-09-23, Team App/Portal, Slice 3 of
  // state/findings/PLAN-availability-poll-cloudflare-rebuild-2026-09-23.md).
  // Runs AFTER the GAS-sourced STATE.polls/render above so a fast D1 read
  // OVERRIDES what the (slower, existing) GAS dashboard payload already
  // painted -- same "paint fast source first, background-verify" posture
  // this project uses elsewhere for CDN-first reads, except here D1 is the
  // faster one being layered ON TOP, not the initial paint. Ships dark
  // behind pollPendingReadEnabled -- no-ops entirely when off, GAS-sourced
  // polls stay exactly as they render today.
  loadPendingPollsFromD1_();
  tnMaybeShowPushPromptForUpcomingJob_();
  renderDashboard();
  /* P4 (2026-06-12): renderDashboard() only repaints the Today panes. If the user
     is on another tab when the silent background refresh lands, repaint that open
     tab too so corrected data shows without a manual tab switch. */
  if (STATE.currentTab === 'schedule') renderSchedule();
  else if (STATE.currentTab === 'profile') loadProfileData();
}

/**
 * Push prompt trigger #3 (added 2026-09-21, TEAMAPP-02-NOTIFICATIONS-AND-
 * PUSH.md §7, §6.8 item 8): "When an artist is allocated a job inside 14
 * days, on next open, in the banner slot, once."
 *
 * This function is called from every renderDashboardData (cache paint AND
 * live refresh), so it must self-limit to "once" itself -- the spec's own
 * word. Fires at most once EVER per device (own localStorage flag,
 * separate from the shared 3x/30d prompt budget), the first time this
 * function observes a job within 14 days in STATE.upcomingBrides. There is
 * no "was this job just allocated, or has it always been on the roster"
 * signal available client-side -- a job appearing within the 14-day
 * window is the closest honest proxy, and the spec's own "once" cap keeps
 * a false-positive (an old, long-known job) from repeatedly re-asking.
 */
function tnMaybeShowPushPromptForUpcomingJob_() {
  try {
    var FIRED_KEY = 'jv_push_prompt_seen_upcoming_job_trigger';
    if (localStorage.getItem(FIRED_KEY)) return; // "once", ever

    var upcoming = STATE.upcomingBrides || [];
    var now = Date.now();
    var FOURTEEN_DAYS_MS = 14 * 24 * 60 * 60 * 1000;
    var hasJobWithin14Days = upcoming.some(function (b) {
      var iso = b && (b.weddingDateIso || b.weddingDate);
      if (!iso) return false;
      var wedTime = new Date(iso + 'T00:00:00').getTime();
      if (isNaN(wedTime)) return false;
      var diff = wedTime - now;
      return diff >= 0 && diff <= FOURTEEN_DAYS_MS;
    });

    if (!hasJobWithin14Days) return;

    localStorage.setItem(FIRED_KEY, '1');
    if (window.jvPushPrompt && typeof window.jvPushPrompt.maybeShow === 'function') {
      window.jvPushPrompt.maybeShow('job_allocated_within_14_days');
    }
  } catch (e) { /* localStorage unavailable -- never block dashboard render */ }
}

/**
 * Load dashboard data.
 *
 * If a fresh cache (under 30 min) exists in _dashboardCache, render
 * it immediately and fire a background GAS refresh. If the cache is
 * stale or absent, show the loading spinner and wait for the GAS
 * response before rendering.
 */
/* Dashboard tasks card CDN fast path (2026-10-01, follow-on to the
   onboarding-status fastpath -- next un-migrated GAS dependency traced in
   this lane). GET /team/tasks (teamTasksHttp.ts) replaces the
   team_app_list_tasks leg of bridge_team_getDashboard. Ships dark behind
   jvTeamApi.tasksReadEnabled() (default false) -- a complete no-op when
   off, same shape as every other CF flag in this file. Deliberately does
   NOT replace the main bridge_team_getDashboard call (that still carries
   today/upcoming/polls/notification-count, none of which this route
   returns) -- runs alongside it and, only on success, overrides
   STATE.openTasks with the fresher/faster D1-sourced list and re-renders.
   Field mapping matches renderDashboardData's own normalisation above
   (taskId->id, taskText->description, dueAt->dueDate) so both paths
   produce byte-identical STATE.openTasks shapes. */
function tryCdnTasksFastPath_() {
  if (dashboardD1ReadEnabled_()) return;
  if (!window.jvTeamApi || !jvTeamApi.tasksReadEnabled || !jvTeamApi.tasksReadEnabled()) return;
  jvTeamApi.getTasks({ limit: 10 }).then(function(data) {
    var results = (data && Array.isArray(data.results)) ? data.results : null;
    if (!results) return; // malformed/empty response -- leave the GAS-sourced list alone
    STATE.openTasks = results.filter(function(t) { return String(t.status || '').toUpperCase() !== 'DONE'; }).map(function(t) {
      return Object.assign({}, t, {
        id: t.id || t.taskId,
        description: t.description || t.taskText,
        dueDate: t.dueDate || t.dueAt
      });
    });
    try { renderTasks(); } catch (e) {}
  }).catch(function() {
    // Best-effort only -- the GAS-sourced task list (from renderDashboardData)
    // already rendered or will render; never block or error the dashboard.
  });
}

/* Client timeout for the dashboard load (2026-10-05). The spinner only clears
   when the call settles, and a call the edge never returns would leave it up
   forever. This rejects after DASH_LOAD_TIMEOUT_MS so the normal error path
   runs (inline error when nothing is cached, shell marker when a cache is shown). */
/* Team dashboard from the Cloudflare read (2026-10-05). Default OFF: only when
   JV_TEAM_CF_CONFIG.dashboardD1Read === true. When on, the dashboard makes ONE
   call to the signed relay read (artist from the verified App Proxy session)
   instead of the GAS dashboard, Next Job card, task fast path and pending-polls
   reads. No GAS fallback in this mode: a failure shows the error state. */
/* Self-heal (2026-10-06, Team App lane): once the Cloudflare read fails in this
   page load, the dashboard drops back to the GAS path for the rest of the visit,
   so a Worker misconfiguration can never leave an artist on a dead page (the
   2026-10-06 baseline outage: theme flag ON, jv-next-pilot route still OFF). */
var _dashD1Failed = false;
function dashboardD1ReadEnabled_() {
  if (_dashD1Failed) return false;
  var cfg = window.JV_TEAM_CF_CONFIG || {};
  return cfg.dashboardD1Read === true || String(cfg.dashboardD1Read) === 'true';
}

/* jv-crm-mirror CF path (2026-10-14, Issue 3 Team App migration).
   Calls the jv-crm-mirror Worker's /team-dashboard/read route via the proxy
   base. Separate from the jv-next-pilot dashboardD1Read path above -- this
   reads from D1 brides/tasks/notifications/polls tables via jv-crm-mirror,
   not from the app proxy's /partner/ namespace.
   Gate: JV_TEAM_CF_CONFIG.dashboardCrmMirrorRead (default OFF).
   Self-heal: shares _dashD1Failed with the other CF path -- any CF failure
   drops the whole page to GAS for the rest of the visit. */
var _dashCrmMirrorFailed = false;
function dashboardCrmMirrorEnabled_() {
  if (_dashCrmMirrorFailed) return false;
  var cfg = window.JV_TEAM_CF_CONFIG || {};
  return cfg.dashboardCrmMirrorRead === true || String(cfg.dashboardCrmMirrorRead) === 'true';
}

function loadDashboardCrmMirror_() {
  var base = window._jvTeamProxyBase;
  if (!base) { fallbackFromCrmMirror_('no_proxy_base'); return; }
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  withDashTimeout_(
    nf(String(base).replace(/\/+$/, '') + '/partner/team-dashboard-mirror/read', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ days: 30, task_limit: 10, bride_limit: 40 }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok || !body || body.ok === false || !body.data) {
            throw new Error('crm_mirror_read_failed');
          }
          return body.data;
        });
      }),
    DASH_LOAD_TIMEOUT_MS
  )
    .then(function (data) {
      showDashboardLoading(false);
      data.cached_at = new Date().toISOString();
      _dashboardCache = data;
      _writeLocalDash_(data);
      renderDashboardData(data, true);
      try { window.jvPortalShell && window.jvPortalShell.hideStale(); } catch (e) {}
    })
    .catch(function (err) {
      fallbackFromCrmMirror_(err && err.message);
    });
}

function fallbackFromCrmMirror_(reason) {
  try { console.warn('[team-dashboard] CRM mirror read failed (' + (reason || 'unknown') + '), falling back'); } catch (e) {}
  _dashCrmMirrorFailed = true;
  loadDashboardData();
  loadDashboardNotifications_();
}

/* Fast-fail mode (2026-10-20, Lane D3, flag custom.team_cf_dashboard_fastfail / cf_dashboard_fastfail,
   default OFF). When ON and the Cloudflare read is the active path: 7s timeout, and a failure/timeout
   never calls GAS getDashboard -- it shows a calm error with Retry, which retries the CF read only. */
var DASH_FASTFAIL_TIMEOUT_MS = 7000;
function dashFastFailEnabled_() {
  var cfg = window.JV_TEAM_CF_CONFIG || {};
  return cfg.dashboardFastFail === true || String(cfg.dashboardFastFail) === 'true';
}
function dashFastFailFailure_(reason, startedAt, httpStatus) {
  var elapsed = Date.now() - startedAt;
  var status = reason === 'dashboard_load_timeout' ? 'timeout' : (httpStatus || reason || 'unknown');
  try { console.warn('[team-dashboard] Cloudflare read failed route=/partner/team-dashboard/read elapsed_ms=' + elapsed + ' status=' + status + ' reason=' + (reason || 'unknown') + ' (fast-fail: no GAS fallback)'); } catch (e) {}
  try { if (window.jvTeamApi && window.jvTeamApi.reportFallback) window.jvTeamApi.reportFallback('dashboard_read', { message: reason, status: httpStatus }); } catch (e) {}
  showDashboardLoading(false);
  showDashboardError(null);
  var dashSection = document.querySelector('.tab-pane[data-tab="dashboard"] .dashboard-section');
  if (!dashSection) return;
  var el = document.createElement('div');
  el.id = 'dashboard-error';
  el.className = 'error-message';
  el.style.margin = '16px';
  var msg = document.createElement('p');
  /* Timeout = genuinely slow; anything else (malformed/shape/HTTP failure) fails instantly, so "taking longer" would be wrong. */
  msg.textContent = reason === 'dashboard_load_timeout'
    ? 'Your dashboard is taking longer than usual to load. Please try again.'
    : 'We could not load your latest dashboard just now. Please try again.';
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn-primary';
  btn.id = 'dashboard-retry';
  btn.textContent = 'Retry';
  btn.addEventListener('click', function () {
    showDashboardError(null);
    showDashboardLoading(true);
    loadDashboardD1_();
  });
  el.appendChild(msg);
  if (window._jvIslandPainted) {
    /* Last saved content is still on screen under this banner: say so, it may be out of date. */
    var stale = document.createElement('p');
    stale.id = 'dashboard-stale-note';
    stale.textContent = 'The details below are from your last visit and may be out of date.';
    el.appendChild(stale);
  }
  el.appendChild(btn);
  dashSection.insertBefore(el, dashSection.firstChild);
  signalDashPainted_();
}
/* Tells jv-push-register.liquid the first paint (or terminal error state) happened so deferred push registration may fire. */
function signalDashPainted_() {
  if (window._jvDashFirstPaint) return;
  window._jvDashFirstPaint = true;
  try { document.dispatchEvent(new Event('jv:dashboard-painted')); } catch (e) {}
}

function loadDashboardD1_() {
  var base = window._jvTeamProxyBase;
  var _ff = dashFastFailEnabled_();
  var _ffStart = Date.now();
  var _ffStatus = null;
  if (!base) { if (_ff) { dashFastFailFailure_('no_proxy_base', _ffStart, null); } else { fallbackFromD1_('no_proxy_base'); } return; }
  var d = new Date();
  var today = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  withDashTimeout_(
    nf(String(base).replace(/\/+$/, '') + '/partner/team-dashboard/read?from=' + today + '&days=' + DASH_D1_WINDOW_DAYS, { method: 'GET' })
      .then(function (r) {
        _ffStatus = r.status;
        return r.json().then(function (body) {
          if (!r.ok || !body || body.ok === false || !body.data || !body.data.page) {
            throw new Error('dashboard_read_failed');
          }
          return body.data.page;
        });
      }),
    _ff ? DASH_FASTFAIL_TIMEOUT_MS : DASH_LOAD_TIMEOUT_MS
  )
    .then(function (page) {
      showDashboardLoading(false);
      var data = { today: page.today || [], upcoming: page.upcoming || [], tasks: page.tasks || [], polls: page.polls || [], cached_at: new Date().toISOString() };
      _dashboardCache = data;
      _writeLocalDash_(data);          // local-first: next visit paints instantly
      renderDashboardData(data, true);
      loadDashboardNotifications_(page.notifications || []);
      try { window.jvPortalShell && window.jvPortalShell.hideStale(); } catch (e) {}
      if (_ff) signalDashPainted_();
    })
    .catch(function (err) {
      if (_ff) { dashFastFailFailure_(err && err.message, _ffStart, _ffStatus); return; }
      fallbackFromD1_(err && err.message);
    });
}

function fallbackFromD1_(reason) {
  try { console.warn('[team-dashboard] Cloudflare read failed (' + (reason || 'unknown') + '), using GAS path'); } catch (e) {}
  try { if (window.jvTeamApi && window.jvTeamApi.reportFallback) window.jvTeamApi.reportFallback('dashboard_read', { message: reason }); } catch (e) {}
  _dashD1Failed = true;
  loadDashboardData();            // now takes the GAS path (local cache paint first)
  loadDashboardNotifications_();  // was skipped at init because D1 mode was on
}

var DASH_LOAD_TIMEOUT_MS = 25000;
/* Cloudflare mode look-ahead, in days. 30 hid real bookings more than a month out
   (e.g. a wedding 6 weeks away did not appear). 180 covers the planning horizon;
   the server caps at 365. */
var DASH_D1_WINDOW_DAYS = 180;
function withDashTimeout_(promise, ms) {
  return new Promise(function (resolve, reject) {
    var done = false;
    var timer = setTimeout(function () {
      if (done) return;
      done = true;
      reject(new Error('dashboard_load_timeout'));
    }, ms);
    promise.then(function (v) {
      if (done) return;
      done = true; clearTimeout(timer); resolve(v);
    }, function (e) {
      if (done) return;
      done = true; clearTimeout(timer); reject(e);
    });
  });
}

function loadDashboardData() {
  showDashboardError(null);
  if (dashboardD1ReadEnabled_()) {
    // Local-first in Cloudflare mode too: paint the last good view instantly.
    var d1Cache = _bestDashCache_();
    if (d1Cache) { renderDashboardData(d1Cache); window._jvIslandPainted = true; }
    else showDashboardLoading(true);
    loadDashboardD1_();
    return;
  }
  if (dashboardCrmMirrorEnabled_()) {
    var cmCache = _bestDashCache_();
    if (cmCache) { renderDashboardData(cmCache); window._jvIslandPainted = true; }
    else showDashboardLoading(true);
    loadDashboardCrmMirror_();
    return;
  }
  tryCdnTasksFastPath_(); // no-op unless jvTeamApi.tasksReadEnabled() -- see its own docblock

  // Layered render priority: localStorage -> metafield CDN -> skeleton.
  // Render ANY available cache instantly (fresh or stale), then always fire
  // a silent background GAS refresh. Spinner only shows on a truly cold load.
  var cache = _bestDashCache_();
  if (cache) {
    renderDashboardData(cache);
    // 2026-08-12 (BRIEFS/FINDING-team-portal-stale-marker-not-wired-2026-08-12.md):
    // tells the shared shell a CDN-cached view is already on screen, so a failed
    // background verify below gets the shell's quiet stale marker instead of
    // total silence. Same flag/mechanism the admin pages have used since 2026-07-31.
    window._jvIslandPainted = true;
  } else {
    showDashboardLoading(true);
  }

  // Background refresh -- the only path that ever pays the GAS cold-start.
  // days/bride_limit shrunk from 365/200 -> 30/40 (2026-09-07,
  // BRIEFS/FINDING-team-dashboard-getdashboard-30s-timeout-2026-09-07.md).
  // team_app_list_upcoming's underlying scan (teamApi_getBookedBrideRowsFull_)
  // loads every booked bride regardless of `days` -- the window only limits how
  // many SURVIVING rows get full per-row enrichment + serialized into the
  // response. 365 days of upcoming weddings was inflating both per-row work and
  // relay payload size on every dashboard load, tipping total round-trip time
  // past the ~7-10s GAS cold-start floor plus the relay's 30s ceiling. A
  // "Coming Up" list realistically only needs a near-term window; 30 days /
  // 40 brides is generous headroom over what any single artist has booked in a
  // month while cutting the worst-case row count by roughly 5x.
  // Issue #3 (2026-10-16): CF-first team-dashboard cache path.
  // Tri-state flag `window.JV_TEAM_DASHBOARD_CF_ENABLED`:
  //   'off'    -> live GAS bridge only (default, legacy behaviour)
  //   'shadow' -> fire BOTH, log a byte diff, serve GAS (safe compare)
  //   'on'     -> fire CF primary; on {ok:false} or network error, fall back to GAS
  // CF endpoint is the cors-relay's App-Proxy path, which the relay
  // (team-dashboard-relay.mjs) rewrites to jv-crm-mirror
  // GET /team/dashboard?artist_email=<verified>&days=30.
  var _jvTdCfMode = (typeof window.JV_TEAM_DASHBOARD_CF_ENABLED === 'string')
    ? window.JV_TEAM_DASHBOARD_CF_ENABLED
    : 'off';
  // Shared CF-call helper (dashboard, upcoming, notifications). Same-origin App Proxy GET; the
  // relay resolves identity from the Shopify signature, so NO email is ever sent from here.
  // Bounded by JV_TEAM_CF_TIMEOUT_MS (default 6000): a slow/hung CF path resolves {ok:false} so
  // the caller can fall back to GAS. Never rejects.
  function _jvTeamCfGet_(path) {
    var timeoutMs = Number(window.JV_TEAM_CF_TIMEOUT_MS) > 0 ? Number(window.JV_TEAM_CF_TIMEOUT_MS) : 6000;
    var timer = null;
    var timeout = new Promise(function(resolve) {
      timer = setTimeout(function() { resolve({ ok: false, _cfTimeout: true }); }, timeoutMs);
    });
    var call;
    try {
      var proxyBase = (window.jvBridge && window.jvBridge.appProxyBase) || '/apps/jv';
      var nf = (window._jvNativeFetch || window.fetch).bind(window);
      call = nf(proxyBase.replace(/\/+$/, '') + path, { method: 'GET', credentials: 'same-origin' })
        .then(function(r) {
          if (!r.ok) return { ok: false, _cfStatus: r.status };
          return r.json().then(function(j) { j._cfSource = 'cf'; return j; });
        })
        .catch(function(e) { return { ok: false, _cfError: String(e && e.message || e) }; });
    } catch (e2) {
      call = Promise.resolve({ ok: false, _cfError: String(e2 && e2.message || e2) });
    }
    return Promise.race([call, timeout]).then(function(v) { clearTimeout(timer); return v; });
  }
  function _jvTdCfFetch_() { return _jvTeamCfGet_('/team-dashboard/cache?days=30'); }
  // GAS is LAZY: in 'on' mode it is fired only after CF fails or times out (C7 fix -- it used to
  // fire in parallel with CF, paying the cold start for nothing). 'off'/'shadow' fire it at once.
  var _jvTdGasCall = null;
  function _jvTdGas_() {
    if (!_jvTdGasCall) _jvTdGasCall = jvBridge.callTeam('bridge_team_getDashboard', { days: 30, task_limit: 10, bride_limit: 40 });
    return _jvTdGasCall;
  }
  var _jvTdPrimary;
  if (_jvTdCfMode === 'on') {
    _jvTdPrimary = _jvTdCfFetch_().then(function(cfRes) {
      if (cfRes && cfRes.ok) return cfRes;
      // CF failed, timed out or disabled -- transparent fallback to GAS
      return _jvTdGas_();
    });
  } else if (_jvTdCfMode === 'shadow') {
    _jvTdPrimary = _jvTdGas_();
    // Fire CF in the background, log a shallow diff. Does not affect UI.
    _jvTdCfFetch_().then(function(cfRes) {
      try {
        var cfOk = !!(cfRes && cfRes.ok);
        console.info('[jv-team-dashboard CF shadow] cf_ok=' + cfOk);
      } catch (_e) {}
    });
  } else {
    _jvTdPrimary = _jvTdGas_();
  }
  // Issue #3 (2026-10-16): CF-first team-upcoming cache path (SIBLING to the
  // dashboard tri-state above, not a replacement -- the dashboard payload
  // already folds upcoming in; this scaffolds a standalone caller that is NOT
  // yet wired to any UI load. Exposed on window so a future "just upcoming"
  // reader (team invoices page, bride-forecast widget, mobile) can import it
  // and pay no GAS cold-start cost of its own.)
  //
  // Tri-state flag `window.JV_TEAM_UPCOMING_CF_ENABLED`:
  //   'off'    -> live GAS bridge only (default, legacy)
  //   'shadow' -> fire BOTH, log cf_ok=, serve GAS
  //   'on'     -> fire CF primary; on {ok:false} or network error, fall back to GAS
  // CF endpoint is the cors-relay's App-Proxy path, which team-upcoming-relay.mjs
  // rewrites to jv-crm-mirror GET /team/upcoming?artist_email=<verified>&days=30.
  if (typeof window.jvTeamUpcomingLoad_ !== 'function') {
    window.jvTeamUpcomingLoad_ = function jvTeamUpcomingLoad_(opts) {
      opts = opts || {};
      var days = Number(opts.days || 30);
      var brideLimit = Number(opts.brideLimit || 40);
      var mode = (typeof window.JV_TEAM_UPCOMING_CF_ENABLED === 'string')
        ? window.JV_TEAM_UPCOMING_CF_ENABLED
        : 'off';
      function cfFetch_() {
        return _jvTeamCfGet_('/team-upcoming/cache?days=' + days + '&bride_limit=' + brideLimit);
      }
      // GAS is LAZY in 'on' mode (fired only on CF failure/timeout); 'off'/'shadow' fire it at once.
      function gasCall_() {
        return (window.jvBridge && typeof window.jvBridge.callTeam === 'function')
          ? window.jvBridge.callTeam('bridge_team_getUpcoming', { days: days, bride_limit: brideLimit })
          : Promise.resolve({ ok: false, error: 'no_jvBridge' });
      }
      if (mode === 'on') {
        return cfFetch_().then(function(cfRes) {
          if (cfRes && cfRes.ok) return cfRes;
          return gasCall_();
        });
      }
      if (mode === 'shadow') {
        cfFetch_().then(function(cfRes) {
          try {
            var cfOk = !!(cfRes && cfRes.ok);
            console.info('[jv-team-upcoming CF shadow] cf_ok=' + cfOk);
          } catch (_e) {}
        });
        return gasCall_();
      }
      return gasCall_();
    };
  }
  withDashTimeout_(
    _jvTdPrimary,
    DASH_LOAD_TIMEOUT_MS
  )
    .then(function(res) {
      showDashboardLoading(false);
      if (res && res.ok) {
        var data = res.data || res;
        data.cached_at = new Date().toISOString();
        _dashboardCache = data;          // keep in-memory copy fresh
        _writeLocalDash_(data);          // persist for next visit / device
        renderDashboardData(data, true); // isLive=true -- see openPollModalFromDeepLink_'s header
        try { window.jvPortalShell && window.jvPortalShell.hideStale(); } catch (e) {}
      } else if (!cache) {
        showDashboardError('Unable to load dashboard data. Please refresh the page.');
      } else {
        // 2026-08-12: was fully silent. Now surfaces the shell's quiet marker
        // (same suppression logic as admin: _jvIslandPainted is set above, so
        // showError() routes to showStale() instead of the loud banner).
        try { window.jvPortalShell && window.jvPortalShell.showError('Unable to refresh dashboard data.'); } catch (e) {}
      }
    })
    .catch(function() {
      showDashboardLoading(false);
      if (!cache) {
        showDashboardError('Could not connect to the team server. Please refresh the page.');
      } else {
        try { window.jvPortalShell && window.jvPortalShell.showError('Could not reach the team server.'); } catch (e) {}
      }
    });
}

function showDashboardLoading(visible) {
  var dashSection = document.querySelector('.tab-pane[data-tab="dashboard"] .dashboard-section');
  if (!dashSection) return;
  var existing = document.getElementById('dashboard-loading');
  if (visible) {
    if (!existing) {
      var el = document.createElement('div');
      el.id = 'dashboard-loading';
      el.className = 'loading';
      el.innerHTML = '<div class="loading-spinner"></div>Loading your dashboard...';
      dashSection.insertBefore(el, dashSection.firstChild);
    }
  } else {
    if (existing) existing.remove();
  }
}

function showDashboardError(msg) {
  var existing = document.getElementById('dashboard-error');
  if (existing) existing.remove();
  if (!msg) return;
  var dashSection = document.querySelector('.tab-pane[data-tab="dashboard"] .dashboard-section');
  if (!dashSection) return;
  var el = document.createElement('div');
  el.id = 'dashboard-error';
  el.className = 'error-message';
  el.style.margin = '16px';
  el.textContent = msg;
  dashSection.insertBefore(el, dashSection.firstChild);
}

/* ============================================================
   RENDER DASHBOARD
   ============================================================ */
function renderDashboard() {
  document.getElementById('artistName').textContent = STATE.artistName;
  renderTodayJobs();
  renderTasks();
  renderAvailability();
  renderUpcoming();
  renderNotificationBadge();
}

/* --- Task 3: Notification badge on Profile tab --- */
function renderNotificationBadge() {
  var count = 0;
  /* Read from cache root or live GAS response stored in STATE */
  if (_dashboardCache && typeof _dashboardCache.unreadNotificationCount === 'number') {
    count = _dashboardCache.unreadNotificationCount;
  } else if (STATE._unreadNotificationCount && typeof STATE._unreadNotificationCount === 'number') {
    count = STATE._unreadNotificationCount;
  }

  /* Added 2026-09-01 (external-GPT existing-value audit finding #3 + note A):
     this badge previously pointed at the Profile TAB, but the Profile PANEL
     had no Notifications destination for it to actually mean anything --
     tapping Profile led nowhere near an unread notification. Now that the
     panel has a real Notifications tile (setupProfileButtons above), give
     that tile its own count so the badge finally points somewhere real.
     Tab-icon badge kept as-is (still a useful "something needs attention in
     Profile" signal). */
  var profileCountEl = document.getElementById('profileNotifCount');
  if (profileCountEl) {
    if (count > 0) {
      profileCountEl.textContent = count > 99 ? '99+' : String(count);
      profileCountEl.style.display = '';
    } else {
      profileCountEl.style.display = 'none';
    }
  }

  var profileTabBtn = document.querySelector('.tab-button[data-tab="profile"]');
  if (!profileTabBtn) return;

  var iconWrapper = profileTabBtn.querySelector('.tab-bar__icon, .tab-icon');
  if (!iconWrapper) return;

  /* Remove any existing badge first */
  var existing = iconWrapper.querySelector('.tab-badge');
  if (existing) existing.remove();

  if (count > 0) {
    /* Ensure wrapper is position:relative for absolute badge positioning */
    iconWrapper.style.position = 'relative';
    iconWrapper.style.display = 'inline-flex';

    var badge = document.createElement('span');
    badge.className = 'tab-badge';
    badge.textContent = count > 99 ? '99+' : String(count);
    iconWrapper.appendChild(badge);
  }
}

/* ============================================================
   TODAY'S JOBS: Stage 1 D1 union (2026-09-25)
   state/findings/PLAN-todays-jobs-d1-migration-2026-09-25.md
   ============================================================
   team_app_today_schedule (TeamAppAPI.gs) classifies Wedding/Trial/
   Consultation/Partner-booking rows purely by regex against raw calendar-
   event TEXT (teamToday_enrichEvent_), with no structured backing except
   Wedding, which the D1 hero card (window.jvTeamApi, /team/jobs) already
   models correctly via team_job_assignments. This function REPLACES the
   calendar-sourced Wedding rows with the D1-sourced ones (D1 owns Wedding
   outright, per the plan's Stage 1 design) and leaves Trial, Consultation,
   and Partner-booking rows exactly as the calendar read already produced
   them (additive, not a wholesale swap). Those three categories stay
   calendar-sourced for now (Stage 2/3 of the plan, not this build).

   Flag-gated: reads the same window.jvTeamApi.isEnabled() gate the hero
   card already uses (this feature has no meaning without the D1 read
   being enabled in the first place, so there is no separate flag to add).
*/
function jvTodayJobs_unionWithD1_(calendarRows) {
  try {
    if (!window.jvTeamApi || typeof window.jvTeamApi.isEnabled !== 'function' || !window.jvTeamApi.isEnabled()) {
      return calendarRows;
    }
    if (typeof window.jvTeamApi.cachedJobs !== 'function') return calendarRows;

    var cached = window.jvTeamApi.cachedJobs();
    var jobsList = (cached && cached.payload && Array.isArray(cached.payload.jobs)) ? cached.payload.jobs : [];
    if (!jobsList.length) return calendarRows;

    var todayIso = localDateISO_(new Date());
    var d1TodayJobs = jobsList.filter(function(j) { return j && j.weddingDate === todayIso; });
    if (!d1TodayJobs.length) return calendarRows;

    /* Drop calendar-sourced rows already classified 'Wedding': D1 owns
       this category outright (Stage 1 design), so a real wedding never
       double-renders (once from the fragile calendar text-match, once
       from the structured D1 read). Trial, Consultation, and Partner-
       booking rows are untouched, D1 does not model them yet (Stage 2/3). */
    var nonWeddingCalendarRows = calendarRows.filter(function(row) {
      return row && row.serviceType !== 'Wedding';
    });

    /* Map each D1 job into the SAME schedule-item shape renderTodayJobs
       already consumes (job.brideId/time/brideName/serviceType/location/
       meetingUrl/isAllDay), same field-mapping discipline as the existing
       "Upcoming" tab precedent (jv-team-dashboard.js ~line 2050,
       bride.arrivalTime/weddingLocation mapped to the schedule shape).

       KNOWN GAP, not silently worked around: the D1 job object carries
       brideShopifyCustomerId, never a bride EMAIL, but openBrideDetail()
       (the calendar-sourced rows' click target) calls
       bridge_team_getBrideDetail with { brideEmail: brideId }, which a
       customer ID cannot satisfy. Rather than pass a customer ID
       pretending it is an email (which would silently 404/error on
       click), D1-sourced rows get NO data-bride-id at all and instead
       carry runsheetHref, matching the hero card's OWN click target
       (/pages/team-job?job=<id>, renderCloudflareNextJob_ ~line 301):
       a real, working destination, not a fabricated identity. */
    var d1Rows = d1TodayJobs.map(function(job) {
      return {
        brideId: '', /* deliberately blank, see comment above */
        runsheetHref: '/pages/team-job?job=' + encodeURIComponent(job.id || ''),
        time: (job.timing && job.timing.startLabel) || '',
        isAllDay: false,
        brideName: job.clientDisplayName || 'Wedding',
        serviceType: 'Wedding',
        location: (job.venue && job.venue.name) || '',
        meetingUrl: ''
      };
    });

    return d1Rows.concat(nonWeddingCalendarRows);
  } catch (e) {
    /* Never let a union-logic failure block the existing calendar-sourced
       render, same fail-safe discipline as the interim guard above this
       function (hasConfirmedJobToday's own try/catch). */
    return calendarRows;
  }
}

function renderTodayJobs() {
  var container = document.getElementById('todayJobsList');
  var countEl = document.getElementById('todayJobCount');

  if (STATE.todaySchedule.length === 0) {
    // P0 fix (2026-08-12, BRIEFS/BUILD-team-app-consolidated-p0-p1-p2-2026-08-12.md):
    // an empty array and a NEVER-CONFIRMED array must never render the same copy.
    // Confirmed live: /pages/team-dashboard showed "0 jobs / Enjoy your day off!"
    // while the underlying fetch was 404ing (TEAM_NOT_AUTHENTICATED) -- a contractor
    // could read that as "nothing booked today" on a real wedding morning. This is
    // the render-side fix; the auth root cause is a separate, already-tracked thread.
    if (!STATE._dashboardConfirmed) {
      container.innerHTML =
        '<div class="empty-state empty-state--unconfirmed">' +
          '<div class="empty-title">Couldn’t confirm your schedule</div>' +
          '<div class="empty-text">This isn’t a confirmed empty day, we couldn’t reach the server to check. Refresh, or check with Jess before assuming you have nothing on.</div>' +
        '</div>';
      countEl.textContent = 'Unconfirmed';
      return;
    }
    // Interim guard (2026-09-22, state/findings/SCOPE-today-jobs-datasource-
    // mismatch-2026-09-22.md): STATE.todaySchedule comes from
    // team_app_today_schedule (TeamAppAPI.gs), which reads Google Calendar
    // events and whole-word string-matches the artist's name -- a
    // structurally different, more fragile source than the D1-backed hero
    // card (window.jvTeamApi, /team/jobs). The two can genuinely disagree: a
    // real D1 job assignment for today can exist while the calendar event's
    // text doesn't happen to contain an exact match of the artist's name.
    // This does NOT fix that mismatch (see the scope doc for why a full
    // reconciliation is real, separate work -- team_app_today_schedule also
    // surfaces trial/EBM/consult events D1 may not model at all) -- it only
    // stops the worst failure mode: never claim "day off" while the D1
    // source the artist already trusts (the TODAY hero card, right above
    // this list) shows a real job for today. Read-only, additive, no new
    // network call -- reuses whatever jvTeamApi has already cached.
    var hasConfirmedJobToday = false;
    try {
      if (window.jvTeamApi && typeof window.jvTeamApi.cachedJobs === 'function') {
        var cachedTodayJobs = window.jvTeamApi.cachedJobs();
        var jobsList = (cachedTodayJobs && cachedTodayJobs.payload && Array.isArray(cachedTodayJobs.payload.jobs))
          ? cachedTodayJobs.payload.jobs : [];
        var todayIso = localDateISO_(new Date());
        hasConfirmedJobToday = jobsList.some(function (j) { return j && j.weddingDate === todayIso; });
      }
    } catch (e) { /* never block render on a cache-read failure */ }

    if (hasConfirmedJobToday) {
      container.innerHTML =
        '<div class="empty-state empty-state--unconfirmed">' +
          '<div class="empty-title">Job may not be showing here</div>' +
          '<div class="empty-text">Your schedule shows a job today, but this list couldn’t match it. Check the card above, or check with Jess before assuming you have nothing on.</div>' +
        '</div>';
      countEl.textContent = 'Check above';
      return;
    }
    container.innerHTML =
      '<div class="empty-state">' +
        '<div class="empty-title">No jobs today</div>' +
        '<div class="empty-text">Enjoy your day off!</div>' +
      '</div>';
    countEl.textContent = '0 jobs';
    return;
  }

  countEl.textContent = STATE.todaySchedule.length + ' job' + (STATE.todaySchedule.length !== 1 ? 's' : '');

  container.innerHTML = STATE.todaySchedule.map(function(job) {
    /* D1-sourced Wedding rows (jvTodayJobs_unionWithD1_) carry
       runsheetHref instead of a bride-email brideId (see that function's
       header for why). data-runsheet-href takes priority in the click
       handler below when present. */
    var hrefAttr = job.runsheetHref ? ' data-runsheet-href="' + escHtml(job.runsheetHref) + '"' : '';
    return '<div class="job-item" data-bride-id="' + escHtml(job.brideId) + '"' + hrefAttr + '>' +
      '<div class="job-time">' + escHtml(job.time || (job.isAllDay ? 'All day' : 'Time TBC')) + '</div>' +
      '<div class="job-details">' +
        '<div class="job-bride">' + escHtml(job.brideName || 'Booking') + '</div>' +
        '<div class="job-meta">' + escHtml(job.serviceType) + '</div>' +
        jvRenderLocationCell_(job.location, 'job-location', job.meetingUrl) +
      '</div>' +
    '</div>';
  }).join('');

  container.querySelectorAll('.job-item').forEach(function(item) {
    item.addEventListener('click', function() {
      var runsheetHref = item.dataset.runsheetHref;
      if (runsheetHref) {
        window.location.href = runsheetHref;
        return;
      }
      openBrideDetail(item.dataset.brideId);
    });
  });
}

function renderTasks() {
  var container = document.getElementById('tasksList');
  var countEl = document.getElementById('taskCount');

  if (STATE.openTasks.length === 0) {
    // P1 fix (2026-08-12, BRIEFS/BUILD-team-app-consolidated-p0-p1-p2-2026-08-12.md):
    // same pattern as renderTodayJobs -- see that function's comment for the
    // confirmed-live incident this generalises to every dashboard card.
    if (!STATE._dashboardConfirmed) {
      container.innerHTML =
        '<div class="empty-state empty-state--unconfirmed" style="padding: 20px;">' +
          '<div class="empty-title">Couldn’t confirm your tasks</div>' +
          '<div class="empty-text">We couldn’t reach the server to check. Refresh to see your real task list.</div>' +
        '</div>';
      countEl.textContent = 'Unconfirmed';
      return;
    }
    container.innerHTML =
      '<div class="empty-state" style="padding: 20px;">' +
        '<div class="empty-title">All caught up!</div>' +
        '<div class="empty-text">No tasks assigned</div>' +
      '</div>';
    countEl.textContent = '0 tasks';
    return;
  }

  countEl.textContent = String(STATE.openTasks.length);

  container.innerHTML = STATE.openTasks.map(function(task) {
    // formUrl/linkUrl wiring (2026-09-08, standing checklist item: "dead task
    // click" bug) -- the bride-detail drawer's own task list already prefers
    // these fields (see the taskUrl handling ~line 1793); this dashboard card
    // used openBrideDetail() unconditionally instead, so a task meant to open
    // a form/link just opened the bride drawer. Same field, same preference
    // order, only wired here now. data-task-url carries the value through to
    // the click handler below without re-deriving it per click.
    var taskUrl = task.formUrl || task.linkUrl || '';
    return '<div class="task-item" data-task-id="' + escHtml(task.id) + '" data-bride-id="' + escHtml(task.brideId) + '" data-task-url="' + escHtml(taskUrl) + '">' +
      '<input type="checkbox" class="task-checkbox" data-task-id="' + escHtml(task.id) + '">' +
      '<div class="task-content">' +
        '<div class="task-bride">' + escHtml(task.brideName) + '</div>' +
        '<div class="task-description">' + escHtml(task.description) + '</div>' +
        // Hide the Due line entirely when there's no date -- a bare "Due:" reads as broken (2026-06-06).
        (formatTaskDate(task.dueDate) ? '<div class="task-due">Due: ' + escHtml(formatTaskDate(task.dueDate)) + '</div>' : '') +
      '</div>' +
    '</div>';
  }).join('');

  container.querySelectorAll('.task-checkbox').forEach(function(checkbox) {
    checkbox.addEventListener('change', function(e) {
      completeTask(e.target.dataset.taskId);
    });
  });

  container.querySelectorAll('.task-item').forEach(function(item) {
    item.addEventListener('click', function(e) {
      if (e.target.classList.contains('task-checkbox')) return;
      var taskUrl = item.dataset.taskUrl || '';
      if (taskUrl) {
        window.open(taskUrl, '_blank', 'noopener');
        return;
      }
      openBrideDetail(item.dataset.brideId);
    });
  });
}

/* "You're already working this date" context for the availability-poll card
   (BRIEFS/BUILD-SCOPE-team-app-notification-features-decided-2026-09-01.md,
   approved item #1, poll-card half). Pure client-side cross-reference of two
   arrays already delivered in the same dashboard payload -- STATE.upcomingBrides
   (this artist's own CONFIRMED bookings, artist-scoped server-side by
   team_app_list_upcoming) against the poll being asked about -- so no new
   backend route or data source is needed. Deliberately does NOT use
   team_job_time_windows (still dark/empty as of this build, see the schema
   handoff) -- date-level matching on data that is already live is sufficient
   for "you're already committed that day," which is the actual ask; a genuine
   time-of-day overlap check is the separate, admin-facing build-order item #2. */
function findSameDateCommitment_(poll) {
  var pollIso = String((poll && poll.weddingDateIso) || '').trim();
  if (!pollIso) return null;
  var list = STATE.upcomingBrides || [];
  for (var i = 0; i < list.length; i++) {
    var b = list[i];
    if (!b || String(b.weddingDateIso || '').trim() !== pollIso) continue;
    // Not a conflict with itself -- the poll is asking about the same bride
    // she's already confirmed on (already responded/booked), not a double-up.
    var pollBride = String((poll.couple || poll.brideName || '')).trim().toLowerCase();
    var bookedBride = String(b.brideName || '').trim().toLowerCase();
    if (pollBride && bookedBride && pollBride === bookedBride) continue;
    return b;
  }
  return null;
}

function renderAvailability() {
  var container = document.getElementById('availabilityList');
  var card = document.getElementById('availabilityCard');

  if (STATE.polls.length === 0) {
    // P1 fix (2026-08-12, BRIEFS/BUILD-team-app-consolidated-p0-p1-p2-2026-08-12.md):
    // hiding this card entirely on a failed/unconfirmed fetch has the same
    // false-confidence shape as the P0 jobs-list bug -- an artist reading "no
    // availability requests" when the card is simply gone. Lower stakes than the
    // wedding-day schedule (these are opt-in asks, not confirmed bookings), so this
    // stays a small visible notice rather than a full unconfirmed-state card.
    if (!STATE._dashboardConfirmed) {
      card.style.display = 'block';
      container.innerHTML =
        '<div class="empty-state empty-state--unconfirmed" style="padding: 16px;">' +
          '<div class="empty-text">Couldn’t confirm whether you have any availability requests, we couldn’t reach the server to check.</div>' +
        '</div>';
      return;
    }
    card.style.display = 'none';
    return;
  }

  card.style.display = 'block';

  /* Availability Poll Action Card (flagship). Each poll renders as a card:
     eyebrow context, couple/bride name, human-readable wedding date,
     optional venue/location line, then the response actions. Options default
     to AVAILABLE / UNAVAILABLE / MAYBE when the backend doesn't supply them,
     so the three intents always show. */
  var DEFAULT_OPTS = ['AVAILABLE', 'UNAVAILABLE', 'MAYBE'];

  container.innerHTML = STATE.polls.map(function(poll) {
    var brideName = poll.couple || poll.brideName || 'this wedding';
    var opts = (poll.options && poll.options.length) ? poll.options : DEFAULT_OPTS;
    var buttonsHtml = opts.map(function(opt) {
      var norm = String(opt).toUpperCase();
      var label = norm === 'AVAILABLE' ? 'Available'
        : norm === 'UNAVAILABLE' ? 'Unavailable'
        : norm === 'MAYBE' ? 'Maybe'
        : escHtml(opt);
      return '<button type="button" class="poll-btn" data-poll-id="' + escHtml(poll.id) + '"' +
        ' data-option="' + escHtml(norm) + '"' +
        ' data-bride-name="' + escHtml(brideName) + '"' +
        ' data-wedding-date="' + escHtml(poll.weddingDate || '') + '"' +
        ' data-wedding-date-iso="' + escHtml(poll.weddingDateIso || '') + '"' +
        ' data-has-conflict="' + (findSameDateCommitment_(poll) ? '1' : '0') + '"' +
        ' data-my-prior-response="' + escHtml(poll.myResponse || '') + '"' +
        ' aria-label="' + label + ' for ' + escHtml(brideName) + '">' +
        label + '</button>';
    }).join('');

    var locationLine = poll.weddingLocation || poll.venue || poll.location || '';
    var conflict = findSameDateCommitment_(poll);

    return '<div class="poll-item" data-poll-id="' + escHtml(poll.id) + '">' +
      '<div class="poll-item__eyebrow">Availability request</div>' +
      '<div class="poll-title">' + escHtml(brideName) + '</div>' +
      '<div class="poll-date">' + formatWeddingDate(poll.weddingDate) + '</div>' +
      (locationLine ? '<div class="poll-meta">' + escHtml(locationLine) + '</div>' : '') +
      (conflict ? '<div class="poll-conflict-note">Heads up, you\'re already booked for ' +
        escHtml(conflict.brideName || 'another wedding') + ' on this date' +
        (conflict.arrivalTime ? ' (arrive ' + escHtml(conflict.arrivalTime) + ')' : '') +
        '.</div>' : '') +
      '<div class="poll-question">Can you work this date?</div>' +
      '<div class="poll-buttons">' + buttonsHtml + '</div>' +
    '</div>';
  }).join('');

  container.querySelectorAll('.poll-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var clickedBtn = e.target.closest('.poll-btn') || e.target;
      var cardEl = clickedBtn.closest('.poll-item');
      if (cardEl && cardEl.classList.contains('is-busy')) return;
      respondToPoll(clickedBtn.dataset.pollId, clickedBtn.dataset.option, clickedBtn);
    });
  });
}

/* Helper: return "Month YYYY" label for grouping upcoming bookings */
function upcomingMonthKey_(bride) {
  var dateStr = bride.weddingDate || bride.weddingDateLabel || '';
  if (!dateStr) return 'Upcoming';
  /* Try ISO date first (YYYY-MM-DD), then fallback to Date parse */
  var d;
  if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    /* Parse as local date to avoid UTC-offset day-shift */
    var parts = dateStr.split('-');
    d = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
  } else {
    d = new Date(dateStr);
  }
  if (isNaN(d.getTime())) return 'Upcoming';
  return AU_MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function renderUpcoming() {
  var container = document.getElementById('upcomingList');
  var countEl = document.getElementById('upcomingCount');

  if (STATE.upcomingBrides.length === 0) {
    // P1 fix (2026-08-12, BRIEFS/BUILD-team-app-consolidated-p0-p1-p2-2026-08-12.md):
    // same pattern as renderTodayJobs -- see that function's comment for the
    // confirmed-live incident this generalises to every dashboard card.
    if (!STATE._dashboardConfirmed) {
      container.innerHTML =
        '<div class="empty-state empty-state--unconfirmed" style="padding: 20px;">' +
          '<div class="empty-text">Couldn’t confirm your upcoming bookings, we couldn’t reach the server to check. Refresh to see your real list.</div>' +
        '</div>';
      countEl.textContent = 'Unconfirmed';
      return;
    }
    container.innerHTML =
      '<div class="empty-state" style="padding: 20px;">' +
        '<div class="empty-text">No upcoming bookings assigned to you</div>' +
      '</div>';
    countEl.textContent = '0';
    return;
  }

  countEl.textContent = String(STATE.upcomingBrides.length);

  /* --- Task 1: Group by calendar month --- */
  var groups = [];
  var groupMap = {};
  STATE.upcomingBrides.forEach(function(bride) {
    var key = upcomingMonthKey_(bride);
    if (!groupMap[key]) {
      groupMap[key] = [];
      groups.push(key);
    }
    groupMap[key].push(bride);
  });

  var html = '';
  groups.forEach(function(monthKey) {
    html += '<div class="upcoming-month-header">' + escHtml(monthKey) + '</div>';

    groupMap[monthKey].forEach(function(bride) {
      var timeRange = '';
      if (bride.arrivalTime && bride.finishTime) {
        timeRange = escHtml(bride.arrivalTime) + ' &ndash; ' + escHtml(bride.finishTime);
      } else if (bride.arrivalTime) {
        timeRange = 'Arrive ' + escHtml(bride.arrivalTime);
      } else if (bride.finishTime) {
        timeRange = 'Finish ' + escHtml(bride.finishTime);
      }

      var isLead = bride.role === 'Lead Artist';

      /* --- Task 4: Pending confirmation pill --- */
      var statusPill = '';
      if (bride.isConfirmed === false) {
        statusPill = '<span class="booking-status-pill booking-status-pill--pending">Pending confirmation</span>';
      }

      /* --- Task 2: Co-artists line --- */
      var coArtistsHtml = '';
      if (bride.coArtists && bride.coArtists.length > 0) {
        coArtistsHtml = '<div class="booking-coartists">' +
          '<span class="booking-coartists__label">With</span>' +
          '<span class="booking-coartists__names">' + escHtml(bride.coArtists.join(', ')) + '</span>' +
          '</div>';
      }

      html += '<div class="upcoming-item" data-bride-id="' + escHtml(bride.brideEmail) + '">' +
        '<div class="upcoming-date-badge">' +
          '<span class="upcoming-date-label">' + escHtml(bride.weddingDateLabel) + '</span>' +
          '<span class="upcoming-role-pill' + (isLead ? ' upcoming-role-lead' : '') + '">' +
            escHtml(bride.role || 'Artist') +
          '</span>' +
          statusPill +
        '</div>' +
        coArtistsHtml +
        '<div class="upcoming-info">' +
          '<div class="upcoming-bride">' + escHtml(bride.brideName) + '</div>' +
          (bride.weddingLocation
            ? '<div class="upcoming-location">' + escHtml(bride.weddingLocation) + '</div>'
            : '') +
          (timeRange
            ? '<div class="upcoming-time">' + timeRange + '</div>'
            : '') +
          (bride.services
            ? '<div class="upcoming-services">' + escHtml(bride.services) + '</div>'
            : '') +
        '</div>' +
      '</div>';
    });
  });

  container.innerHTML = html;

  container.querySelectorAll('.upcoming-item').forEach(function(item) {
    item.addEventListener('click', function() {
      openBrideDetail(item.dataset.brideId);
    });
  });
}

/* ============================================================
   TASK COMPLETION
   ============================================================ */
/* Flag-off writes retain the legacy D1-outbox/GAS rollback chain. Once the direct
   task-complete mode is ON, Cloudflare is authoritative and failures stay failed;
   completeTask() restores the checkbox so the artist can retry. */
function teamWriteTask_(taskId) {
  var api = window.jvTeamApi;
  var gas = function () { return jvBridge.callTeam('bridge_team_completeTask', { taskId: taskId }); };

  /* Issue #3 Slice 2a (2026-10-16): direct CF write path to team_tasks.
     Tri-state via api.taskCompleteCfMode() -- 'off' (fall through to the
     existing outbox/GAS chain), 'shadow' (fire BOTH, use GAS result, log
     CF outcome), 'on' (CF authoritative, no GAS fallback). */
  var cfMode = (api && typeof api.taskCompleteCfMode === 'function') ? api.taskCompleteCfMode() : 'off';

  if (cfMode === 'on' && api && typeof api.completeTaskDirect === 'function') {
    return api.completeTaskDirect(taskId).then(function (res) {
      return { ok: true, alreadyCompleted: !!(res && res.alreadyCompleted) };
    });
  }

  if (cfMode === 'shadow' && api && typeof api.completeTaskDirect === 'function') {
    /* Fire-and-log, do not block the user-facing result on it. */
    try {
      api.completeTaskDirect(taskId).then(
        function (res) { try { console.log('[task-complete-shadow] CF ok', { taskId: taskId, alreadyCompleted: !!(res && res.alreadyCompleted) }); } catch (e) {} },
        function (err) { try { console.warn('[task-complete-shadow] CF failed', taskId, err && err.message); } catch (e) {} }
      );
    } catch (e) { /* never let a shadow fire break the real write */ }
    /* Fall through to the existing authoritative path (outbox or GAS). */
  }

  if (!(api && api.writeOutboxEnabled && api.writeOutboxEnabled())) return gas();
  return api.completeTask(taskId).then(function () { return { ok: true }; }, gas);
}
function teamWriteNotifRead_(notificationId) {
  var api = window.jvTeamApi;
  var gas = function () { return jvBridge.callTeam('bridge_team_markNotificationRead', { notificationId: notificationId }); };
  if (!(api && api.writeOutboxEnabled && api.writeOutboxEnabled())) return gas();
  return api.markNotificationRead(notificationId).then(function () { return { ok: true }; });
}

function completeTask(taskId) {
  var checkbox = document.querySelector('input.task-checkbox[data-task-id="' + taskId + '"]');
  if (checkbox) checkbox.disabled = true;

  teamWriteTask_(taskId)
    .then(function(res) {
      if (res && res.ok) {
        var item = document.querySelector('.task-item[data-task-id="' + taskId + '"]');
        if (item) {
          item.style.transition = 'opacity 0.2s';
          item.style.opacity = '0';
          setTimeout(function() {
            item.remove();
            STATE.openTasks = STATE.openTasks.filter(function(t) { return String(t.id) !== String(taskId); });
            var countEl = document.getElementById('taskCount');
            if (countEl) countEl.textContent = STATE.openTasks.length === 0 ? '0 tasks' : String(STATE.openTasks.length);
          }, 220);
        }
      } else {
        if (checkbox) { checkbox.checked = false; checkbox.disabled = false; }
      }
    })
    .catch(function() {
      if (checkbox) { checkbox.checked = false; checkbox.disabled = false; }
    });
}

/* ============================================================
   POLL RESPONSE
   ============================================================ */
/* Availability Poll submit (S7b flow + S8 lifecycle).
   Optimistic: the tapped intent lights up and the card locks immediately, so
   the response feels instant even while GAS takes a few seconds. On success a
   Confirmation Toast shows and the card collapses to a confirmed line; on
   failure the card unlocks and an Error Toast invites a retry (S8: a failed
   action shows an error, it never silently strands the poll). */
// onDone (optional, added 2026-09-12 fix for F1): called exactly once, after
// the real outcome is known -- success (whichever branch), block-day decline,
// or failure -- never on a fixed timer. The modal close handler is passed in
// as onDone by renderPollModalBody_'s click wiring; the inline Availability
// card passes nothing, since it has no modal to close.
function respondToPoll(pollId, option, btn, onDone) {
  var norm = String(option || '').toUpperCase();
  var brideName = (btn && btn.dataset.brideName) || '';
  var weddingDateIso = (btn && btn.dataset.weddingDateIso) || '';
  var hasConflict = !!(btn && btn.dataset.hasConflict === '1');
  var cardEl = btn && btn.closest('.poll-item');

  /* Optimistic UI */
  if (cardEl) {
    cardEl.classList.add('is-busy');
    cardEl.querySelectorAll('.poll-btn').forEach(function(b) { b.classList.remove('selected'); });
  }
  if (btn) btn.classList.add('selected');

  var friendly = norm === 'AVAILABLE' ? 'available'
    : norm === 'UNAVAILABLE' ? 'unavailable'
    : norm === 'MAYBE' ? 'a maybe' : norm.toLowerCase();

  // D1-native respond path (2026-09-23, Team App/Portal, Slice 2/3 of
  // state/findings/PLAN-availability-poll-cloudflare-rebuild-2026-09-23.md).
  // Same feature-flag-check -> D1-or-GAS pattern already established for
  // Availability block/unblock (pollOfferBlockDate_ below, jv-team-
  // cloudflare.js's own header). Ships dark behind pollRespondEnabled --
  // GAS remains the path for everyone until this is explicitly turned on.
  var usesD1Respond = window.jvTeamApi && window.jvTeamApi.pollRespondEnabled && window.jvTeamApi.pollRespondEnabled();

  // isFirstUnavailable for the D1 path: computed client-side from the poll's
  // OWN prior response (already known -- this poll came from
  // getPendingPolls()'s myResponse field, fetched before this tap), same
  // truth GAS's server-side previousResponse check answers. NOT ported:
  // GAS's isFirstUnavailable also protects against a same-tab double-submit
  // race (two rapid taps before the first completes) by checking the
  // SHEET's state at write time, not just what the client believed before
  // the tap. The D1 path does not yet guard that race -- acceptable for a
  // dark-shipped flag (worst case: the "block the day?" prompt shows on a
  // rapid double-tap it shouldn't), not acceptable to claim as fully at
  // parity. Flagged here rather than silently assumed equivalent.
  var priorResponseForD1 = (btn && btn.dataset.myPriorResponse) || null;

  /* GAS respond, the original path. Used directly when the D1 flag is off AND as the FALLBACK when the D1 call fails
     (route 404/5xx, offline Worker, poll not mirrored yet): an artist's answer must never be lost, and the sheet is
     what admin reads. Same payload shape as before (full name first: see the jvAuth.fullName note above). */
  function respondViaGas_() {
    return jvBridge.callTeam('bridge_team_respondAvailability', {
      artist_name: (window.jvAuth && (window.jvAuth.fullName || window.jvAuth.name)) || '',
      bride_name: brideName,
      wedding_date: (btn && btn.dataset.weddingDate) || '',
      response: norm
    });
  }

  var op;
  if (usesD1Respond) {
    var idempotencyKey = 'poll-respond-' + pollId + '-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    op = window.jvTeamApi.respondToPollD1(pollId, norm, idempotencyKey).then(function(result) {
      return {
        ok: true,
        data: {
          isFirstUnavailable: norm === 'UNAVAILABLE' && priorResponseForD1 !== 'unavailable' && !result.replay
        }
      };
    }).catch(function(d1Err) {
      // D1 path failed: fall back to GAS so the answer is recorded where admin reads it. A genuine D1 success whose
      // reply was lost in transit is harmless to repeat: same answer, same key space (GAS upserts by bride+artist).
      console.warn('Poll D1 respond failed, falling back to GAS:', d1Err && d1Err.message);
      if (window.jvTeamApi && window.jvTeamApi.reportFallback) window.jvTeamApi.reportFallback('poll_respond', d1Err);
      return respondViaGas_();
    });
  } else {
    op = respondViaGas_();
  }

  op
    .then(function(res) {
      if (!res || !res.ok) {
        console.warn('Poll response failed:', res);
        // onDone is deliberately NOT called on failure -- see
        // pollResponseFailed_'s own comment. The modal (if any) stays open
        // so the artist can see the error and retry.
        pollResponseFailed_(cardEl);
        return;
      }
      // FIX 2026-09-12 (F2): mark the poll answered in STATE the moment the
      // server confirms the response -- BEFORE the optional block-day
      // sub-prompt, not after it. Previously this only happened inside
      // pollResponseConfirmed_, which the block-day branch does not reach
      // until "Block the day" / "Just this one" is tapped. Any background
      // dashboard refresh in between called renderAvailability(), which
      // rebuilds the whole list from STATE.polls and wiped the prompt back
      // to an "unanswered" card -- even though the UNAVAILABLE response was
      // already saved server-side. Removing it from STATE.polls here means
      // a refresh can no longer resurrect a poll whose answer already
      // landed, regardless of which UI sub-state is currently showing.
      if (STATE && Array.isArray(STATE.polls)) {
        STATE.polls = STATE.polls.filter(function(p) { return p && String(p.id) !== String(pollId); });
        renderPendingPollsBanner(STATE.polls.filter(function(p) { return p && !p.responded; }).length);
      }
      /* Approved feature (2026-09-01, FEATURE-CHECKLIST-team-app item #1):
         offer "block the whole date" ONLY on a genuine first UNAVAILABLE tap
         (server-confirmed via isFirstUnavailable -- never on a retry/repeat),
         and never when this artist already has a CONFLICTING confirmed job
         that date (hasConflict) -- she said unavailable for THIS bride because
         she's double-booked, not because the whole day is free. */
      var data = res.data || {};
      if (norm === 'UNAVAILABLE' && data.isFirstUnavailable && !hasConflict && weddingDateIso) {
        pollOfferBlockDate_(cardEl, pollId, norm, brideName, friendly, weddingDateIso, onDone);
        return;
      }
      pollResponseConfirmed_(cardEl, pollId, norm, brideName, friendly, false, onDone);
    })
    .catch(function(err) {
      console.error('Poll response error:', err);
      pollResponseFailed_(cardEl);
    });
}

/* Follow-up sub-prompt after a first genuine UNAVAILABLE tap: ask whether to
   block the whole date (calScheduler_blockDate via the existing hard-block
   route) so future polls for that date skip this artist automatically. Same
   card, same visual language as the poll response itself -- no modal. Explicit
   opt-in only; declining (or ignoring) leaves just this one booking declined. */
// onDone (added 2026-09-12, F1 fix): threaded through from respondToPoll so
// the modal (if any) closes only once the block-day decision itself
// resolves -- never while this sub-prompt is still on screen.
//
// F3 fix (added 2026-09-22, TEAMAPP-tap-through investigation, still open
// as of tonight -- verified against live source before fixing, not
// assumed): this used to offer the block-day sub-prompt with NO
// acknowledgement of the underlying UNAVAILABLE response, which was
// already saved server-side by the time this function runs (respondToPoll
// awaits a real ok:true before calling this). If the artist ignores the
// sub-prompt entirely -- closes the app, scrolls away, gets a call -- she
// had no confirmation anywhere that her response was recorded, only an
// open question on screen. Now fires the same confirmation toast
// pollResponseConfirmed_ would show, immediately, before rendering the
// additive block-day choice -- matching the spec's own instruction: "fire
// the confirmation immediately, then offer the block-day upgrade as an
// additive, dismissible choice."
function pollOfferBlockDate_(cardEl, pollId, norm, brideName, friendly, weddingDateIso, onDone) {
  if (!cardEl) { pollResponseConfirmed_(cardEl, pollId, norm, brideName, friendly, false, onDone); return; }
  showToast_("Thanks, you're marked " + friendly + '.', 'success');
  cardEl.classList.remove('is-busy');
  cardEl.innerHTML =
    '<div class="poll-item__eyebrow">Availability request</div>' +
    '<div class="poll-title">' + escHtml(brideName) + '</div>' +
    '<div class="poll-question">Marked unavailable. Block the whole day so future requests skip you too?</div>' +
    '<div class="poll-buttons">' +
      '<button type="button" class="poll-btn" data-block-action="yes">Block the day</button>' +
      '<button type="button" class="poll-btn" data-block-action="no">Just this one</button>' +
    '</div>';

  cardEl.querySelector('[data-block-action="yes"]').addEventListener('click', function() {
    cardEl.classList.add('is-busy');
    var idempotencyKey = 'avail-block-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    var reason = 'Declined via availability poll for ' + brideName;
    // GAS RETIRED (lane G1, 2026-10-19): availabilityWriteEnabled is ON live (theme + Worker D1 write
    // path). No bridge_team_blockDate fallback: if the CF write is off, fail LOUD.
    if (!(window.jvTeamApi && window.jvTeamApi.availabilityWriteEnabled && window.jvTeamApi.availabilityWriteEnabled())) {
      console.error('[JV_TEAM_AVAIL_CF_WRITE_DISABLED] availabilityWriteEnabled is off; GAS blockDate fallback retired');
      showToast_('Could not block the date. Availability changes are temporarily unavailable.', 'error');
      cardEl.classList.remove('is-busy');
      return;
    }
    var op = window.jvTeamApi.blockAvailability(weddingDateIso, reason, idempotencyKey);
    op.then(function(res) {
      if (!res || !res.ok) {
        showToast_((res && res.error) || 'Could not block the date. Please try again.', 'error');
        cardEl.classList.remove('is-busy');
        // Do NOT call onDone here -- the artist is still mid-decision (the
        // block failed but her UNAVAILABLE response is already saved); a
        // modal close now would strand her on a dashboard with no visible
        // outcome. Leave the modal open so she can see the error and retry.
        return;
      }
      pollResponseConfirmed_(cardEl, pollId, norm, brideName, friendly, true, onDone);
    }).catch(function() {
      showToast_('Network error. Please try again.', 'error');
      cardEl.classList.remove('is-busy');
    });
  });

  cardEl.querySelector('[data-block-action="no"]').addEventListener('click', function() {
    pollResponseConfirmed_(cardEl, pollId, norm, brideName, friendly, false, onDone);
  });
}

/* Success: collapse the card to a confirmed line, drop it from pending state,
   refresh the pending-polls banner count, show the Confirmation Toast.
   dateBlocked (optional): true when this confirm follows a "yes, block the
   whole day" choice from pollOfferBlockDate_ -- shows that outcome instead of
   the plain "marked unavailable" line. onDone (added 2026-09-12, F1 fix):
   called last, after the visible confirmed state and toast are in place --
   this is the ONLY place (besides pollResponseFailed_) that should ever
   close a poll modal now; there is no more fixed-timer close. */
function pollResponseConfirmed_(cardEl, pollId, norm, brideName, friendly, dateBlocked, onDone) {
  if (cardEl) {
    cardEl.classList.remove('is-busy');
    cardEl.classList.add('is-done');
    var checkSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    var label = dateBlocked ? 'Marked unavailable, whole day blocked'
      : norm === 'AVAILABLE' ? 'Marked available'
      : norm === 'UNAVAILABLE' ? 'Marked unavailable'
      : 'Marked maybe';
    cardEl.innerHTML =
      '<div class="poll-item__eyebrow">Availability request</div>' +
      '<div class="poll-title">' + escHtml(brideName) + '</div>' +
      '<div class="poll-item__done">' + checkSvg + '<span>' + label + '</span></div>';
  }

  /* Drop the answered poll from local state (idempotent -- respondToPoll's
     success handler already does this for the non-block-day path, this
     covers the block-day branch and stays safe to re-run either way) so a
     background refresh doesn't resurrect it, and re-derive the pending
     banner count. */
  if (STATE && Array.isArray(STATE.polls)) {
    STATE.polls = STATE.polls.filter(function(p) { return p && String(p.id) !== String(pollId); });
    renderPendingPollsBanner(STATE.polls.filter(function(p) { return p && !p.responded; }).length);
    var card = document.getElementById('availabilityCard');
    if (card && STATE.polls.length === 0) {
      /* Leave the confirmed line visible briefly, then hide the empty card. */
      setTimeout(function() {
        if (STATE.polls.length === 0) card.style.display = 'none';
      }, 4200);
    }
  }

  if (dateBlocked) {
    showToast_("Thanks, and the whole day's blocked too.", 'success');
  } else {
    showToast_("Thanks, you're marked " + friendly + '.', 'success');
  }

  // Push prompt trigger #1 (added 2026-09-21, TEAMAPP-02-NOTIFICATIONS-AND-
  // PUSH.md §7, §6.8 item 8): "After the artist responds to an availability
  // request for the first time. She has just experienced the thing push
  // exists to deliver." Fires only the FIRST time this device sees a
  // confirmed response (own localStorage flag, separate from the shared
  // 3x/30d push-prompt budget in jv-push-register.liquid -- this only marks
  // that the trigger MOMENT happened, not that a prompt was shown; the gate
  // itself lives in jvPushPrompt.maybeShow). window.jvPushPrompt may not
  // exist if jv-push-register.liquid didn't load on this page (defensive,
  // never throws).
  try {
    var firstResponseKey = 'jv_push_prompt_seen_first_poll_response';
    if (!localStorage.getItem(firstResponseKey)) {
      localStorage.setItem(firstResponseKey, '1');
      if (window.jvPushPrompt && typeof window.jvPushPrompt.maybeShow === 'function') {
        window.jvPushPrompt.maybeShow('first_poll_response');
      }
    }
  } catch (e) { /* localStorage unavailable -- never block the confirmation */ }

  // Leave the confirmed state on screen briefly (same visual feedback the
  // old fixed 900ms timer intended) before closing, but only now that the
  // real outcome is actually known and shown.
  if (typeof onDone === 'function') {
    setTimeout(onDone, 900);
  }
}

/* Failure: unlock the card so the artist can retry, and show an Error Toast.
   onDone (added 2026-09-12, F1 fix): deliberately NOT called here -- a
   failed response must leave the modal (if any) open so the artist can see
   the error and retry, rather than closing over a silent failure. */
function pollResponseFailed_(cardEl) {
  if (cardEl) {
    cardEl.classList.remove('is-busy');
    cardEl.querySelectorAll('.poll-btn').forEach(function(b) { b.classList.remove('selected'); });
  }
  showToast_('Could not save your response. Please try again.', 'error');
}

/* ============================================================
   SEARCH
   ============================================================ */
function setupSearch() {
  var input = document.getElementById('searchInput');
  var searchTimeout;

  input.addEventListener('input', function(e) {
    clearTimeout(searchTimeout);
    var query = e.target.value.trim();

    if (query.length === 0) {
      document.getElementById('searchResults').classList.remove('active');
      document.getElementById('searchNoResults').style.display = 'block';
      return;
    }

    document.getElementById('searchNoResults').style.display = 'none';
    document.getElementById('searchResults').classList.add('active');

    searchTimeout = setTimeout(function() {
      performSearch(query);
    }, 300);
  });
}

/* Out-of-order guard (BUG-team-search-brides-zero-results-2026-08-27.md,
   secondary finding): a fast keystroke followed by a slower one can have
   its responses arrive in the WRONG order (GAS cold-start latency is
   variable, 7-10s+), so an earlier, now-stale response landing after a
   later one was overwriting the container with results for a query the
   user had already moved past. _searchSeq_ tags each request; only the
   response matching the CURRENT sequence number is ever painted. */
var _searchSeq_ = 0;

function renderSearchResults_(results, query, mySeq, container) {
  if (mySeq !== _searchSeq_) return; // a newer search has since been fired

  if (!results.length) {
    container.innerHTML =
      '<div class="search-no-results">' +
        'No brides found matching "' + escHtml(query) + '"' +
      '</div>';
    container.classList.add('active');
    return;
  }

  container.innerHTML = results.map(function(bride) {
    // Phase 2 (2026-06-05 / Disease A): BE returns brideName / weddingDateIso /
    // brideEmail / services (not name / id / weddingDate). brideEmail is the click
    // target (same id convention as the Upcoming list).
    var bid = bride.brideEmail || bride.id || '';
    var bname = bride.brideName || bride.name || '';
    var bdate = bride.weddingDateIso || bride.weddingDate || '';
    var bservices = bride.services || '';
    return '<div class="search-result-item" data-bride-id="' + escHtml(bid) + '">' +
      '<div class="search-result-name">' + escHtml(bname) + '</div>' +
      '<div class="search-result-meta">Wedding: ' + formatWeddingDate(bdate) + '</div>' +
      (bservices ? '<div class="search-result-services">' + escHtml(bservices) + '</div>' : '') +
    '</div>';
  }).join('');

  container.classList.add('active');

  container.querySelectorAll('.search-result-item').forEach(function(item) {
    item.addEventListener('click', function() {
      openBrideDetail(item.dataset.brideId);
    });
  });
}

/* Search bar CF-first read (2026-10-14, Issue 3 CF migration slice 5).
   Same convention as brideDetailCrmMirrorEnabled_ / the dashboard mirror --
   admin + flag gated client-side (the Worker route enforces admin-only
   either way, see worker.js handleTeamBrideSearchRead's security note). */
function brideSearchCrmMirrorEnabled_() {
  if (!(window.jvAuth && window.jvAuth.role === 'admin')) return false;
  var cfg = window.JV_TEAM_CF_CONFIG || {};
  return cfg.brideSearchCrmMirrorRead === true || String(cfg.brideSearchCrmMirrorRead) === 'true';
}

function performSearch(query) {
  var container = document.getElementById('searchResults');
  var mySeq = ++_searchSeq_;

  var gasFallback = function () {
    jvBridge.callTeam('bridge_team_searchBrides', { search: query })
      .then(function(res) {
        // BUG-team-search-brides-zero-results-2026-08-27.md: bridge_team_searchBrides
        // returns res.data as {status, count, results} (team_app_search_brides's own
        // shape, TeamAppAPI.gs), NOT the results array directly. Reading res.data as
        // the array meant .length was always undefined -> always "No brides found",
        // for every query, regardless of real matches. assets/jv-runsheet-view.js's
        // own search caller already reads resp.data.results correctly off this same
        // shape -- this was the one caller that had it wrong.
        var results = (res && res.ok && res.data) ? (res.data.results || []) : [];
        renderSearchResults_(results, query, mySeq, container);
      })
      .catch(function(err) {
        console.error('Search error:', err);
      });
  };

  if (!brideSearchCrmMirrorEnabled_()) { gasFallback(); return; }

  var base = window._jvTeamProxyBase;
  if (!base) { gasFallback(); return; }
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(String(base).replace(/\/+$/, '') + '/partner/team-bride-search-mirror/read', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ search: query, limit: 30 }),
    credentials: 'same-origin'
  })
    .then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok || !body || body.ok === false || !body.data) {
          throw new Error('bride_search_mirror_read_failed');
        }
        return body.data.results || [];
      });
    })
    .then(function (results) {
      renderSearchResults_(results, query, mySeq, container);
    })
    .catch(function () {
      gasFallback();
    });
}

/* ============================================================
   SCHEDULE TAB
   ============================================================ */
function loadScheduleData() {
  renderSchedule();
}

function renderSchedule() {
  var container = document.getElementById('scheduleList');
  var allEvents = [];

  var todayDate = localDateISO_();
  STATE.todaySchedule.forEach(function(event) {
    allEvents.push({
      brideName: event.brideName,
      brideId: event.brideId,
      time: event.time,
      isAllDay: event.isAllDay,
      serviceType: event.serviceType,
      location: event.location,
      meetingUrl: event.meetingUrl,
      date: todayDate,
      isToday: true
    });
  });

  STATE.upcomingBrides.forEach(function(bride) {
    // Phase 2 (2026-06-05 / Disease A): the BE upcoming items use
    // brideName / brideEmail / arrivalTime / weddingLocation / weddingDateIso, not
    // name / id / time / location / weddingDate. Map to the schedule shape.
    var bdate = bride.weddingDateIso || bride.weddingDate || '';
    allEvents.push({
      brideName: bride.brideName || bride.name || '',
      brideId: bride.brideEmail || bride.id || '',
      time: bride.arrivalTime || bride.time || '',
      serviceType: bride.services || '',
      location: bride.weddingLocation || bride.location || '',
      date: bdate,
      isToday: bdate === todayDate
    });
  });

  allEvents.sort(function(a, b) {
    var dateA = new Date(a.date);
    var dateB = new Date(b.date);
    if (dateA.getTime() !== dateB.getTime()) return dateA - dateB;
    return (a.time || '').localeCompare(b.time || '');
  });

  var grouped = {};
  allEvents.forEach(function(event) {
    if (!grouped[event.date]) grouped[event.date] = [];
    grouped[event.date].push(event);
  });

  var html = '';
  Object.keys(grouped).sort().forEach(function(date) {
    var isToday = date === todayDate;
    var dateLabel = formatScheduleDateHeader(date);

    html += '<div class="schedule-date-group">' +
      '<div class="schedule-date-header ' + (isToday ? 'today' : '') + '">' +
        dateLabel + (isToday ? ' · Today' : '') +
      '</div>';

    grouped[date].forEach(function(event) {
      var isPast = isToday && event.time && new Date(date + 'T' + event.time + ':00') < new Date();
      html += '<div class="schedule-event ' + (isPast ? 'past' : '') + '" data-bride-id="' + escHtml(event.brideId) + '">' +
        '<div class="schedule-time">' + escHtml(event.time || (event.isAllDay ? 'All day' : 'Time TBC')) + '</div>' +
        '<div class="schedule-details">' +
          '<div class="schedule-bride">' + escHtml(event.brideName || 'Booking') + '</div>' +
          '<div class="schedule-type">' + escHtml(event.serviceType) + '</div>' +
          jvRenderLocationCell_(event.location, 'schedule-location', event.meetingUrl) +
        '</div>' +
      '</div>';
    });

    html += '</div>';
  });

  if (!html) {
    html = '<div class="empty-state"><div class="empty-text">No upcoming events</div></div>';
  }

  container.innerHTML = html;

  container.querySelectorAll('.schedule-event').forEach(function(item) {
    item.addEventListener('click', function() {
      openBrideDetail(item.dataset.brideId);
    });
  });
}

/* ============================================================
   PROFILE TAB
   ============================================================ */
function loadProfileData() {
  renderProfile();
}

function renderProfile() {
  document.getElementById('profileName').textContent = STATE.artistName;
  document.getElementById('profileRole').textContent = STATE.artistRole;

  var skillsContainer = document.getElementById('profileSkills');
  var skillsList = [
    { name: 'Hair', key: 'hair' },
    { name: 'Makeup', key: 'makeup' },
    { name: 'Can Lead', key: 'canLead' }
  ];

  skillsContainer.innerHTML = skillsList.map(function(skill) {
    var active = STATE.skills[skill.key];
    return '<div class="skill-badge ' + (active ? '' : 'inactive') + '">' +
      '<span class="skill-check">' + (active ? '&#10003;' : '&#9675;') + '</span>' +
      escHtml(skill.name) +
    '</div>';
  }).join('');
}

/* ============================================================
   PROFILE BUTTONS
   ============================================================ */
function setupProfileButtons() {
  var notificationsBtn = document.getElementById('notificationsBtn');
  if (notificationsBtn) {
    notificationsBtn.addEventListener('click', function() {
      window.location.href = '/pages/team-notifications';
    });
  }

  var invoicesBtn = document.getElementById('invoicesBtn');
  if (invoicesBtn) {
    invoicesBtn.addEventListener('click', function() {
      window.location.href = '/pages/team-invoices';
    });
  }

  document.getElementById('contactJessicaBtn').addEventListener('click', function() {
    window.location.href = 'mailto:hello@jessicavegas.com?subject=Team%20Member%20Query';
  });

  document.getElementById('handbookBtn').addEventListener('click', function() {
    window.open('/pages/team-handbook', '_blank');
  });

  var availabilityBtn = document.getElementById('availabilityBtn');
  if (availabilityBtn) {
    availabilityBtn.addEventListener('click', function() {
      window.location.href = '/pages/team-availability';
    });
  }

  var editProfileBtn = document.getElementById('editProfileBtn');
  if (editProfileBtn) {
    editProfileBtn.addEventListener('click', function() {
      window.location.href = '/pages/team-profile';
    });
  }

  document.getElementById('logoutBtn').addEventListener('click', function() {
    window.location.href = '/account/logout';
  });
}

/* ============================================================
   HELPERS
   ============================================================ */
/* Bride drawer CF-first read (2026-10-14, Issue 3 CF migration slice 2).
   Calls jv-crm-mirror's /team-bride-detail/read via the /partner/ relay,
   same convention as loadDashboardCrmMirror_ above. Admin-only: the Worker
   route itself rejects non-admin callers (see worker.js
   handleTeamBrideDetailRead's security note -- ASSIGNED_ARTIST/STAFF
   CONFIRMED aren't mirrored to D1 yet, so a non-admin per-artist assignment
   check can't be done server-side there today). Checking admin here too
   just saves a doomed round trip for artists; the route enforces it either
   way. Gate: JV_TEAM_CF_CONFIG.brideDetailCrmMirrorRead (default OFF). */
function brideDetailCrmMirrorEnabled_() {
  if (!(window.jvAuth && window.jvAuth.role === 'admin')) return false;
  var cfg = window.JV_TEAM_CF_CONFIG || {};
  return cfg.brideDetailCrmMirrorRead === true || String(cfg.brideDetailCrmMirrorRead) === 'true';
}

function openBrideDetail(brideId) {
  if (!brideId) return;
  injectDrawerStyles_();
  showBrideDrawer_({ loading: true });

  var gasFallback = function () {
    jvBridge.callTeam('bridge_team_getBrideDetail', { brideEmail: brideId })
      .then(function(res) {
        if (res && res.ok && res.data) {
          showBrideDrawer_({ loading: false, data: res.data });
        } else {
          showBrideDrawer_({ loading: false, error: (res && res.error) || 'Unable to load bride details.' });
        }
      })
      .catch(function() {
        showBrideDrawer_({ loading: false, error: 'Network error. Please try again.' });
      });
  };

  if (!brideDetailCrmMirrorEnabled_()) { gasFallback(); return; }

  var base = window._jvTeamProxyBase;
  if (!base) { gasFallback(); return; }
  var nf = (window._jvNativeFetch || window.fetch).bind(window);
  nf(String(base).replace(/\/+$/, '') + '/partner/team-bride-detail-mirror/read', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ bride_email: brideId }),
    credentials: 'same-origin'
  })
    .then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok || !body || body.ok === false || !body.data) {
          throw new Error('bride_detail_mirror_read_failed');
        }
        return body.data;
      });
    })
    .then(function (data) {
      showBrideDrawer_({ loading: false, data: data });
    })
    .catch(function () {
      gasFallback();
    });
}

var _drawerStylesInjected = false;
function injectDrawerStyles_() {
  if (_drawerStylesInjected) return;
  _drawerStylesInjected = true;
  var style = document.createElement('style');
  style.textContent = [
    /* Drawer base */
    '.jv-drawer-overlay{position:fixed;inset:0;background:rgba(30,23,22,0.45);z-index:9998;opacity:0;transition:opacity 0.25s;pointer-events:none;}',
    '.jv-drawer-overlay.open{opacity:1;pointer-events:auto;}',
    '.jv-drawer{position:fixed;bottom:0;left:0;right:0;max-height:88vh;background:#fff;border-radius:1.5rem 1.5rem 0 0;z-index:9999;transform:translateY(100%);transition:transform 0.3s cubic-bezier(0.25,0.46,0.45,0.94);overflow-y:auto;-webkit-overflow-scrolling:touch;}',
    '.jv-drawer.open{transform:translateY(0);}',
    '.jv-drawer-handle{width:36px;height:4px;background:rgba(47,37,36,0.15);border-radius:2px;margin:12px auto 0;}',
    '.jv-drawer-inner{padding:16px 20px 32px;position:relative;}',
    '.jv-drawer-close{position:absolute;top:0;right:0;background:none;border:none;cursor:pointer;padding:8px;color:#8a7e7b;line-height:1;}',
    '.jv-drawer-bride-name{font-family:"Raleway",sans-serif;font-size:22px;font-weight:300;color:#1e1716;margin-bottom:2px;padding-right:32px;}',
    '.jv-drawer-wedding-date{font-size:13px;color:#c99591;font-weight:600;margin-bottom:4px;}',
    '.jv-drawer-section{margin-bottom:12px;}',
    '.jv-drawer-label{font-size:10px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#c99591;margin-bottom:3px;}',
    '.jv-drawer-value{font-size:14px;color:#2f2524;line-height:1.4;}',
    '.jv-drawer-divider{height:1px;background:rgba(47,37,36,0.08);margin:14px 0;}',
    '.jv-drawer-task-item{padding:9px 0;border-top:1px solid rgba(47,37,36,0.07);font-size:13px;color:#2f2524;line-height:1.4;}',
    '.jv-drawer-task-item:first-child{border-top:none;}',
    '.jv-drawer-task-due{font-size:11px;color:#8a7e7b;margin-top:2px;}',
    '.jv-drawer-runsheet-btn{display:block;width:100%;margin-top:18px;padding:13px;background:#c99591;color:#fff;border:none;border-radius:3rem;font-size:14px;font-weight:600;font-family:inherit;cursor:pointer;text-align:center;text-decoration:none;letter-spacing:0.02em;transition:background 0.15s;}',
    '.jv-drawer-runsheet-btn:hover{background:#a9706c;color:#fff;}',
    '.jv-drawer-empty{font-size:13px;color:#8a7e7b;font-style:italic;}',
    '.jv-drawer-loading{text-align:center;padding:32px 20px;}',
    '@keyframes jv-drawer-spin{to{transform:rotate(360deg);}}',
    '.jv-drawer-spinner{width:28px;height:28px;border:2.5px solid rgba(201,149,145,0.25);border-top-color:#c99591;border-radius:50%;animation:jv-drawer-spin 0.8s linear infinite;margin:0 auto 12px;}',

    /* Task 1 - Month headers in upcoming list */
    '.upcoming-month-header{font-family:"Raleway",sans-serif;font-weight:600;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.12em;color:var(--brand-primary,#c99591);padding:1rem 0 0.4rem;border-bottom:1px solid rgba(201,149,145,0.2);margin-bottom:0.5rem;position:sticky;top:0;background:var(--brand-bg-white,#fff);z-index:2;}',

    /* Task 2 - Co-artists line */
    '.booking-coartists{display:flex;gap:0.35rem;align-items:center;font-size:0.78rem;color:var(--brand-text,#2f2524);opacity:0.65;margin-top:0.25rem;}',
    '.booking-coartists__label{font-style:italic;}',

    /* Task 3 - Notification badge */
    '.tab-badge{position:absolute;top:-2px;right:-6px;background:var(--brand-primary,#c99591);color:#fff;font-size:0.6rem;font-weight:700;min-width:16px;height:16px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;padding:0 4px;line-height:1;pointer-events:none;}',
    '.tab-bar__icon,.tab-icon{position:relative;display:inline-flex;}',

    /* Task 4 - Status pills */
    '.booking-status-pill{display:inline-block;font-size:0.65rem;font-weight:600;text-transform:uppercase;letter-spacing:0.08em;padding:0.2rem 0.6rem;border-radius:999px;margin-left:0.4rem;}',
    '.booking-status-pill--pending{background:rgba(201,149,145,0.15);color:var(--brand-primary,#c99591);}',

    /* Task 5 - Bride drawer quick-actions */
    '.bride-drawer-actions{display:flex;gap:0.75rem;margin:0.75rem 0 1rem;}',
    '.bride-drawer-action{display:inline-flex;align-items:center;gap:0.4rem;font-family:"Raleway",sans-serif;font-size:0.8rem;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;color:var(--brand-primary,#c99591);text-decoration:none;border:1px solid var(--brand-primary,#c99591);border-radius:999px;padding:0.5rem 1rem;min-height:44px;transition:background 0.2s,color 0.2s;}',
    '.bride-drawer-action:hover,.bride-drawer-action:active{background:var(--brand-primary,#c99591);color:#fff;}',
    '.bride-drawer-action svg{width:14px;height:14px;flex-shrink:0;}'
  ].join('');
  document.head.appendChild(style);
}

function showBrideDrawer_(opts) {
  var overlay = document.getElementById('jv-bride-drawer-overlay');
  var drawer  = document.getElementById('jv-bride-drawer');

  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'jv-bride-drawer-overlay';
    overlay.className = 'jv-drawer-overlay';
    overlay.addEventListener('click', closeBrideDrawer_);
    document.body.appendChild(overlay);
  }
  if (!drawer) {
    drawer = document.createElement('div');
    drawer.id = 'jv-bride-drawer';
    drawer.className = 'jv-drawer';
    document.body.appendChild(drawer);
  }

  if (opts.loading) {
    drawer.innerHTML = '<div class="jv-drawer-handle"></div>' +
      '<div class="jv-drawer-loading"><div class="jv-drawer-spinner"></div>' +
      '<div style="font-size:13px;color:#8a7e7b;">Loading details…</div></div>';
    requestAnimationFrame(function() {
      overlay.classList.add('open');
      drawer.classList.add('open');
    });
    return;
  }

  overlay.classList.add('open');
  drawer.classList.add('open');

  if (opts.error) {
    drawer.innerHTML = '<div class="jv-drawer-handle"></div>' +
      '<div class="jv-drawer-inner"><button class="jv-drawer-close" onclick="closeBrideDrawer_()" aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button><div style="padding:16px 0;font-size:14px;color:#b32727;">' + escHtml(opts.error) + '</div></div>';
    return;
  }

  var d = opts.data;
  var bride = d.bride || d;
  var links = d.links || {};
  var tasks = (d.tasks && d.tasks.open) || d.openTasks || [];
  // Team-facing runsheet link (2026-08-30 fix): runsheetViewLink is the live
  // published-runsheet view; runsheetLink (CRM column "RUNSHEET LINK") is the
  // legacy raw Google Sheet, which is no longer the team-facing surface.
  // Falling back to it here meant an artist whose runsheet hadn't been
  // published yet was silently sent to a raw internal spreadsheet instead of
  // seeing "not published yet" -- confirmed live (Erin Wilson, 2026-08-30).
  // Only ever use the real view link; never the raw sheet.
  var runsheetUrl = links.runsheetViewLink || '';
  // Inspiration/trial folder links (2026-09-03, external-GPT existing-value
  // audit finding #6): team_app_get_bride_detail already returns these two
  // fields -- fetched but never rendered until Jess's explicit decision this
  // session that artists ARE allowed to see them (helps prep for a job).
  // clientFolder is deliberately NOT surfaced -- that decision only covered
  // inspiration/trial, not the general client folder.
  var trialFolderUrl = links.trialFolder || '';
  var inspirationFolderUrl = links.inspirationFolder || '';

  var tasksHtml = tasks.length
    ? '<div class="jv-drawer-label">Open Tasks (' + tasks.length + ')</div>' +
      tasks.map(function(t) {
        // Contract fix (2026-09-01, external-GPT existing-value audit finding
        // #1): team_app_get_bride_detail (TeamAppAPI.gs) returns taskText/
        // dueAt as the canonical field names -- description/title/
        // task_description and dueDate/due_date were never sent, so every
        // task here rendered blank. taskText/dueAt checked first; the old
        // names kept as fallbacks in case any other caller ever used them.
        var taskUrl = t.formUrl || t.linkUrl || '';
        var taskLabel = escHtml(t.taskText || t.description || t.title || t.task_description || '');
        var taskDue = t.dueAt || t.dueDate || t.due_date;
        return '<div class="jv-drawer-task-item">' +
          (taskUrl
            ? '<a href="' + escHtml(taskUrl) + '" target="_blank" rel="noopener">' + taskLabel + '</a>'
            : taskLabel) +
          (taskDue ? '<div class="jv-drawer-task-due">Due ' + formatTaskDate(taskDue) + '</div>' : '') +
        '</div>';
      }).join('')
    : '<div class="jv-drawer-label">Tasks</div><div class="jv-drawer-empty">No open tasks</div>';

  var servicesStr = Array.isArray(bride.services) ? bride.services.join(', ') : (bride.services || '');
  var timeStr = (bride.arrivalTime || '') + (bride.arrivalTime && bride.finishTime ? ' – ' : '') + (bride.finishTime || '');

  /* --- Task 5: Call + message quick-actions --- */
  var drawerActionsHtml = '';
  if (bride.phone) {
    drawerActionsHtml =
      '<div class="bride-drawer-actions">' +
        '<a href="tel:' + escHtml(bride.phone) + '" class="bride-drawer-action">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.5a16 16 0 0 0 6.6 6.6l.87-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>' +
          '</svg>' +
          ' Call' +
        '</a>' +
        '<a href="sms:' + escHtml(bride.phone) + '" class="bride-drawer-action bride-drawer-action--sms">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>' +
          '</svg>' +
          ' Message' +
        '</a>' +
      '</div>';
  }

  drawer.innerHTML = '<div class="jv-drawer-handle"></div>' +
    '<div class="jv-drawer-inner">' +
      '<button class="jv-drawer-close" onclick="closeBrideDrawer_()" aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<div class="jv-drawer-bride-name">' + escHtml(bride.brideName || ((bride.firstName || '') + ' ' + (bride.lastName || '')).trim()) + '</div>' +
      '<div class="jv-drawer-wedding-date">' + escHtml(bride.weddingDate ? formatWeddingDate(bride.weddingDate) : '') + '</div>' +
      drawerActionsHtml +
      (bride.weddingLocation ? '<div class="jv-drawer-section"><div class="jv-drawer-label">Venue</div><div class="jv-drawer-value">' + escHtml(bride.weddingLocation) + '</div></div>' : '') +
      (timeStr ? '<div class="jv-drawer-section"><div class="jv-drawer-label">Time</div><div class="jv-drawer-value">' + escHtml(timeStr) + '</div></div>' : '') +
      (servicesStr ? '<div class="jv-drawer-section"><div class="jv-drawer-label">Services</div><div class="jv-drawer-value">' + escHtml(servicesStr) + '</div></div>' : '') +
      (bride.partySize ? '<div class="jv-drawer-section"><div class="jv-drawer-label">Party</div><div class="jv-drawer-value">' + escHtml(String(bride.partySize)) + ' people</div></div>' : '') +
      '<div class="jv-drawer-divider"></div>' +
      tasksHtml +
      (runsheetUrl
        ? '<a href="' + escHtml(runsheetUrl) + '" target="_blank" class="jv-drawer-runsheet-btn">View Runsheet</a>'
        : '<span style="display:block;margin-top:18px;font-size:13px;color:var(--brand-text,#2f2524);opacity:0.55;">Runsheet being prepared. Check back closer to the wedding day.</span>') +
      ((trialFolderUrl || inspirationFolderUrl)
        ? '<div class="jv-drawer-section" style="margin-top:14px;">' +
            '<div class="jv-drawer-label">Reference</div>' +
            (trialFolderUrl ? '<a href="' + escHtml(trialFolderUrl) + '" target="_blank" rel="noopener" style="display:block;font-size:13px;color:var(--brand-primary,#c99591);margin-top:4px;">Trial photos &amp; notes</a>' : '') +
            (inspirationFolderUrl ? '<a href="' + escHtml(inspirationFolderUrl) + '" target="_blank" rel="noopener" style="display:block;font-size:13px;color:var(--brand-primary,#c99591);margin-top:4px;">Inspiration folder</a>' : '') +
          '</div>'
        : '') +
    '</div>';
}

function closeBrideDrawer_() {
  var overlay = document.getElementById('jv-bride-drawer-overlay');
  var drawer  = document.getElementById('jv-bride-drawer');
  if (overlay) overlay.classList.remove('open');
  if (drawer)  drawer.classList.remove('open');
}

/* ============================================================
   TOAST HELPER - lightweight inline notification
   ============================================================ */
/* Toast (S5h): bottom-centre, role=status/aria-live=polite, gentle fade.
   variant: 'success' (auto-dismiss 4s), 'error' (6s), or neutral (default 3s).
   Backwards compatible: showToast_('message') still shows a neutral toast. */
function showToast_(msg, variant) {
  var existing = document.getElementById('jv-td-toast');
  if (existing) existing.remove();

  var bg = 'rgba(30,23,22,0.90)';
  var dismissMs = 3000;
  if (variant === 'success') { bg = 'var(--color-success, #6E9B7A)'; dismissMs = 4000; }
  else if (variant === 'error') { bg = 'var(--color-error, #B46A6A)'; dismissMs = 6000; }

  var toast = document.createElement('div');
  toast.id = 'jv-td-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.textContent = msg;
  toast.style.cssText = [
    'position:fixed',
    'bottom:88px',
    'left:50%',
    'transform:translateX(-50%)',
    'background:' + bg,
    'color:#fff',
    'font-size:13px',
    'font-weight:600',
    'font-family:inherit',
    'padding:11px 20px',
    'border-radius:999px',
    'box-shadow:0 12px 32px -6px rgba(47,37,36,0.28)',
    'z-index:99999',
    'max-width:calc(100vw - 32px)',
    'text-align:center',
    'pointer-events:none',
    'opacity:0',
    'transition:opacity 200ms cubic-bezier(0.16,1,0.3,1)'
  ].join(';');
  document.body.appendChild(toast);

  /* Entrance fade (200ms), then hold, then exit fade (150ms). */
  requestAnimationFrame(function() { toast.style.opacity = '1'; });

  setTimeout(function() {
    toast.style.transitionDuration = '150ms';
    toast.style.opacity = '0';
    setTimeout(function() {
      if (toast.parentNode) toast.remove();
    }, 170);
  }, dismissMs);
}

/* PWA install (2026-07-15 build).
   Registers the SW and shows a dismissible "Add to Home Screen" banner.
   Skipped entirely inside the FluxBuilder native app (html.jv-in-app)
   since that shell already has its own install/OneSignal path. */
(function () {
  'use strict';

  if (document.documentElement.classList.contains('jv-in-app')) return;
  if (!('serviceWorker' in navigator)) return;

  var DISMISS_KEY = 'jv_team_pwa_banner_dismissed_v1';

  function isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
  }

  if (!window.JV_TEAM_SW_URL) return;
  // No explicit scope: Shopify's asset CDN won't send the
  // Service-Worker-Allowed header, so scope is pinned to the SW file's
  // own directory regardless. Installability only needs a controlling
  // worker on this page, not a site-wide scope.
  navigator.serviceWorker.register(window.JV_TEAM_SW_URL)
    .catch(function () {});

  if (isStandalone()) return;
  try {
    if (localStorage.getItem(DISMISS_KEY) === '1') return;
  } catch (e) {}

  var isIos = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
  var deferredPrompt = null;
  var nativePromptFired = false;

  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    deferredPrompt = e;
    nativePromptFired = true;
    showBanner('android');
  });

  if (isIos) {
    // iOS never fires beforeinstallprompt, show manual instructions instead.
    setTimeout(function () { showBanner('ios'); }, 1200);
  } else {
    // Shopify's CDN can't send the header a scoped service worker needs
    // to unlock Chrome's native one-tap install button, so beforeinstallprompt
    // may never fire. Fall back to manual "Add to Home Screen" instructions
    // if the native prompt hasn't shown up after a few seconds.
    setTimeout(function () {
      if (!nativePromptFired) showBanner('android-manual');
    }, 3000);
  }

  function dismiss(banner) {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
    if (banner && banner.parentNode) banner.remove();
  }

  function showBanner(kind) {
    if (document.getElementById('jv-pwa-install-banner')) return;

    var banner = document.createElement('div');
    banner.id = 'jv-pwa-install-banner';
    banner.style.cssText = [
      'position:fixed', 'left:16px', 'right:16px', 'bottom:16px',
      'z-index:9999', 'background:var(--brand-bg-white,#fff)',
      'border-radius:1rem', 'box-shadow:0 18px 48px rgba(47,37,36,0.18)',
      'padding:16px 18px', 'display:flex', 'align-items:center', 'gap:12px',
      'font-family:inherit', 'border:1px solid rgba(201,149,145,0.25)'
    ].join(';');

    var text = document.createElement('div');
    text.style.cssText = 'flex:1;font-size:13px;line-height:1.4;color:var(--brand-text,#2f2524);';
    text.textContent = kind === 'ios'
      ? 'Install the Team app: tap Share, then "Add to Home Screen".'
      : kind === 'android-manual'
      ? 'Install the Team app: tap the menu (top right), then "Add to Home Screen" or "Install app".'
      : 'Install the Team app on this device for job alerts and one-tap access.';

    var actions = document.createElement('div');
    actions.style.cssText = 'display:flex;gap:8px;flex-shrink:0;';

    if (kind === 'android') {
      var installBtn = document.createElement('button');
      installBtn.type = 'button';
      installBtn.textContent = 'Install';
      installBtn.className = 'btn-primary';
      installBtn.style.cssText = 'padding:8px 16px;font-size:13px;white-space:nowrap;';
      installBtn.addEventListener('click', function () {
        if (!deferredPrompt) { dismiss(banner); return; }
        deferredPrompt.prompt();
        deferredPrompt.userChoice.finally(function () {
          deferredPrompt = null;
          dismiss(banner);
        });
      });
      actions.appendChild(installBtn);
    }

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Dismiss');
    closeBtn.textContent = 'Not now';
    closeBtn.className = 'btn-ghost';
    closeBtn.style.cssText = 'padding:8px 14px;font-size:13px;white-space:nowrap;';
    closeBtn.addEventListener('click', function () { dismiss(banner); });
    actions.appendChild(closeBtn);

    banner.appendChild(text);
    banner.appendChild(actions);
    document.body.appendChild(banner);
  }

  window.addEventListener('appinstalled', function () {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
    var b = document.getElementById('jv-pwa-install-banner');
    if (b) b.remove();
  });
})();
